var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 97,
    viewBox: "0 0 104 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35154_85969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.18 85.6808C72.0225 85.6808 88.1081 69.6782 88.1081 49.9381C88.1081 30.1979 72.0225 14.1953 52.18 14.1953C32.3375 14.1953 16.252 30.1979 16.252 49.9381C16.252 69.6782 32.3375 85.6808 52.18 85.6808Z",
    fill: "url(#paint0_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.18 85.6808C72.0225 85.6808 88.1081 69.6782 88.1081 49.9381C88.1081 30.1979 72.0225 14.1953 52.18 14.1953C32.3375 14.1953 16.252 30.1979 16.252 49.9381C16.252 69.6782 32.3375 85.6808 52.18 85.6808Z",
    fill: "#E3F2FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.403646,
    d: "M24.3134 91.613C27.5111 91.613 30.1033 89.0208 30.1033 85.8231C30.1033 82.6254 27.5111 80.0332 24.3134 80.0332C21.1157 80.0332 18.5234 82.6254 18.5234 85.8231C18.5234 89.0208 21.1157 91.613 24.3134 91.613Z",
    fill: "url(#paint1_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_35154_85969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7473 12.209H69.7035C72.7924 12.209 75.2965 14.713 75.2965 17.802V77.6389C75.2965 80.7278 72.7924 83.2319 69.7035 83.2319H34.7473C31.6584 83.2319 29.1543 80.7278 29.1543 77.6389V17.802C29.1543 14.713 31.6584 12.209 34.7473 12.209Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.7473 12.209H69.7035C72.7924 12.209 75.2965 14.713 75.2965 17.802V77.6389C75.2965 80.7278 72.7924 83.2319 69.7035 83.2319H34.7473C31.6584 83.2319 29.1543 80.7278 29.1543 77.6389V17.802C29.1543 14.713 31.6584 12.209 34.7473 12.209Z",
    fill: "url(#paint2_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25029 20.1425L59.789 15.0305C59.789 15.0305 55.2761 4.77831 47.8206 3.46289C47.8206 3.46289 13.4213 5.08187 10.7419 5.19116C8.07458 5.30044 0.538213 6.75348 2.25029 20.1425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35479 20.1711L59.8935 15.0227C59.8935 15.0227 55.3805 4.7705 47.9251 3.45508C47.9251 3.45508 13.5217 5.08621 10.8464 5.21168C8.17908 5.34119 0.638667 6.78614 2.35479 20.1711Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46026 20.2035L59.9989 15.0227C59.9989 15.0227 55.486 4.7705 48.0306 3.45508C48.0306 3.45508 13.6272 5.09835 10.9518 5.24001C8.28455 5.38167 0.744136 6.81447 2.46026 20.2035Z",
    fill: "#FDFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56268 20.236L60.1013 15.0188C60.1013 15.0188 55.5884 4.7666 48.133 3.45117C48.133 3.45117 13.7256 5.10658 11.0542 5.26443C8.39102 5.42228 0.850603 6.84699 2.56268 20.236Z",
    fill: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66815 20.2646L60.2068 15.011C60.2068 15.011 55.6939 4.75878 48.2385 3.44336C48.2385 3.44336 13.827 5.11091 11.1597 5.28495C8.49649 5.46304 0.956072 6.87965 2.66815 20.2646Z",
    fill: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77265 20.297L60.3113 15.011C60.3113 15.011 55.7984 4.75878 48.343 3.44336C48.343 3.44336 13.9315 5.12306 11.2642 5.31329C8.60099 5.50352 1.05653 6.90798 2.77265 20.297Z",
    fill: "#FAFBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87312 20.3275L60.4118 15.0051C60.4118 15.0051 55.8989 4.75292 48.4435 3.4375C48.4435 3.4375 14.0279 5.12934 11.3647 5.33576C8.70551 5.54218 1.16104 6.93855 2.87312 20.3275Z",
    fill: "#F9FAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97858 20.356L60.5173 15.0012C60.5173 15.0012 56.0044 4.74902 48.5489 3.43359C48.5489 3.43359 14.1334 5.13757 11.4702 5.36018C8.81097 5.57875 1.26651 6.97107 2.97858 20.356Z",
    fill: "#F9FAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08504 20.3885L60.6237 14.9973C60.6237 14.9973 56.1108 4.74511 48.6554 3.42969C48.6554 3.42969 14.2358 5.14581 11.5726 5.38461C8.91743 5.61936 1.36892 6.99955 3.08504 20.3885Z",
    fill: "#F8F9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18551 20.4211L60.7242 14.9934C60.7242 14.9934 56.2113 4.74121 48.7558 3.42578C48.7558 3.42578 14.3363 5.15405 11.673 5.40499C9.02194 5.65998 1.47344 7.03207 3.18551 20.4211Z",
    fill: "#F7F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29097 20.4495L60.8337 14.9895C60.8337 14.9895 56.3208 4.7373 48.8654 3.42188C48.8654 3.42188 14.4417 5.16228 11.7825 5.42941C9.12741 5.70059 1.5789 7.06459 3.29097 20.4495Z",
    fill: "#F6F7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39548 20.4821L60.9382 14.9856C60.9382 14.9856 56.4253 4.73339 48.9699 3.41797C48.9699 3.41797 14.5422 5.17052 11.887 5.45384C9.23191 5.74121 1.67935 7.09306 3.39548 20.4821Z",
    fill: "#F5F7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50094 20.5146L61.0437 14.9817C61.0437 14.9817 56.5308 4.72949 49.0753 3.41406C49.0753 3.41406 14.6476 5.17875 11.9925 5.47827C9.33738 5.78183 1.78482 7.12558 3.50094 20.5146Z",
    fill: "#F4F6FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60141 20.543L61.1441 14.9778C61.1441 14.9778 56.6312 4.72558 49.1758 3.41016C49.1758 3.41016 14.7441 5.18699 12.093 5.50269C9.4419 5.82244 1.88934 7.1581 3.60141 20.543Z",
    fill: "#F3F5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60154 20.5411L61.1443 14.9758C61.1443 14.9758 56.6313 4.72363 49.1759 3.4082C49.1759 3.4082 15.752 5.97834 12.8702 6.05524C10.1908 6.12809 1.88947 7.15615 3.60154 20.5411Z",
    fill: "url(#paint3_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1559 96.808L93.7715 88.6928C85.1099 82.9738 78.8809 76.4493 76.8126 65.3147C74.8415 54.7266 76.0881 34.7807 74.8982 23.6785C73.7123 12.5561 72.0447 6.67107 64.7552 4.16165C63.0513 3.57477 61.6266 3.32383 59.9631 3.14574C56.7049 2.79361 50.7834 3.19026 50.7834 3.19026L9.40625 5.31518C9.40625 5.31518 10.9524 5.2747 12.3002 5.84944C16.9183 7.82055 20.0025 13.9039 21.6539 22.8933C24.1673 36.5778 23.7221 56.0622 24.1026 67.302C24.6611 83.8075 29.4655 97.8968 36.1559 96.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3299 96.7797L93.9374 88.6928C85.2758 82.9738 79.0468 76.4493 76.9785 65.3147C75.0074 54.7266 76.254 34.7807 75.064 23.6785C73.8741 12.5561 72.2066 6.66703 64.9211 4.16165C63.2171 3.57477 61.7924 3.32383 60.1289 3.14574C56.8707 2.79361 50.9493 3.19026 50.9493 3.19026L9.57617 5.30708C9.57617 5.30708 11.1183 5.2747 12.4661 5.84944C17.0842 7.82055 20.1684 13.9039 21.8197 22.8933C24.3332 36.5778 23.888 56.0622 24.2684 67.302C24.827 83.8075 29.6394 97.8684 36.3299 96.7797Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4998 96.7513L94.1032 88.6928C85.4417 82.9738 79.2126 76.4493 77.1444 65.3147C75.1733 54.7266 76.4199 34.7807 75.2299 23.6785C74.04 12.5561 72.3724 6.66703 65.087 4.16165C63.383 3.57477 61.9583 3.32383 60.2948 3.14574C57.0366 2.79361 51.1152 3.19026 51.1152 3.19026L9.74609 5.30303C9.74609 5.30303 11.2841 5.27875 12.6319 5.85349C17.2501 7.8246 20.3342 13.9079 21.9856 22.8973C24.4991 36.5818 24.0539 56.0663 24.4343 67.3061C24.9929 83.8075 29.8093 97.8401 36.4998 96.7513Z",
    fill: "#FDFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6699 96.723L94.2652 88.6928C85.6036 82.9738 79.3746 76.4493 77.3064 65.3147C75.3352 54.7266 76.5819 34.7807 75.3919 23.6785C74.202 12.5561 72.5344 6.66703 65.249 4.16165C63.545 3.57477 62.1203 3.32383 60.4568 3.14574C57.1986 2.79361 51.2771 3.19026 51.2771 3.19026L9.91211 5.29494C9.91211 5.29494 11.4461 5.2747 12.7939 5.84944C17.412 7.82055 20.4962 13.9039 22.1476 22.8933C24.6611 36.5778 24.2158 56.0622 24.5963 67.302C25.1589 83.8075 29.9794 97.8118 36.6699 96.723Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8438 96.6947L94.4351 88.6928C85.7736 82.9738 79.5445 76.4493 77.4763 65.3147C75.5052 54.7266 76.7518 34.7807 75.5618 23.6785C74.3719 12.5561 72.7043 6.66703 65.4189 4.16165C63.7149 3.57477 62.2902 3.32383 60.6267 3.14574C57.3685 2.79361 51.4471 3.19026 51.4471 3.19026L10.082 5.28684C10.082 5.28684 11.616 5.2747 12.9638 5.84944C17.582 7.82055 20.6661 13.9039 22.3175 22.8933C24.831 36.5778 24.3858 56.0622 24.7662 67.302C25.3248 83.8075 30.1534 97.7834 36.8438 96.6947Z",
    fill: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0139 96.6663L94.5971 88.6928C85.9355 82.9738 79.7065 76.4493 77.6382 65.3147C75.6671 54.7266 76.9137 34.7807 75.7238 23.6785C74.5338 12.5561 72.8663 6.66703 65.5809 4.16165C63.8769 3.57477 62.4522 3.32383 60.7887 3.14574C57.5305 2.79361 51.609 3.19026 51.609 3.19026L10.248 5.2828C10.248 5.2828 11.778 5.27875 13.1258 5.85349C17.7439 7.8246 20.8281 13.9079 22.4795 22.8973C24.9929 36.5818 24.5477 56.0663 24.9282 67.3061C25.4908 83.8075 30.3234 97.7551 37.0139 96.6663Z",
    fill: "#FAFBFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1838 96.638L94.763 88.6928C86.1014 82.9738 79.8724 76.4493 77.8041 65.3147C75.833 54.7266 77.0796 34.7807 75.8897 23.6785C74.6997 12.5561 73.0322 6.66703 65.7467 4.16165C64.0428 3.57477 62.618 3.32383 60.9545 3.14574C57.6963 2.79361 51.7749 3.19026 51.7749 3.19026L10.418 5.2747C10.418 5.2747 11.9439 5.2747 13.2917 5.84944C17.9098 7.82055 20.994 13.9039 22.6453 22.8933C25.1588 36.5778 24.7136 56.0622 25.0941 67.302C25.6567 83.8075 30.4974 97.7268 37.1838 96.638Z",
    fill: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3578 96.6097L94.9288 88.6928C86.2673 82.9738 80.0382 76.4493 77.97 65.3147C75.9989 54.7266 77.2455 34.7807 76.0555 23.6785C74.8656 12.5561 73.198 6.66703 65.9126 4.16165C64.2086 3.57477 62.7839 3.32383 61.1204 3.14574C57.8622 2.79361 51.9408 3.19026 51.9408 3.19026L10.5879 5.26661C10.5879 5.26661 12.1097 5.2747 13.4575 5.84944C18.0757 7.82055 21.1599 13.9039 22.8112 22.8933C25.3247 36.5778 24.8795 56.0622 25.2599 67.302C25.8225 83.8075 30.6673 97.6984 37.3578 96.6097Z",
    fill: "#F9FAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5277 96.5813L95.0947 88.6928C86.4332 82.9738 80.2041 76.4493 78.1359 65.3147C76.1647 54.7266 77.4114 34.7807 76.2214 23.6785C75.0355 12.5561 73.3679 6.67107 66.0785 4.16165C64.3745 3.57477 62.9498 3.32383 61.2863 3.14574C58.0281 2.79361 52.1066 3.19026 52.1066 3.19026L10.7578 5.26256C10.7578 5.26256 12.2756 5.27875 13.6234 5.85349C18.2416 7.8246 21.3257 13.9079 22.9771 22.8973C25.4906 36.5818 25.0453 56.0663 25.4258 67.3061C25.9844 83.8075 30.8373 97.6701 37.5277 96.5813Z",
    fill: "#F8F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7017 96.553L95.2646 88.6928C86.6031 82.9738 80.374 76.4493 78.3058 65.3147C76.3347 54.7266 77.5813 34.7807 76.3913 23.6785C75.2014 12.5561 73.5338 6.66703 66.2484 4.16165C64.5444 3.57477 63.1197 3.32383 61.4562 3.14574C58.198 2.79361 52.2766 3.19026 52.2766 3.19026L10.9277 5.25446C10.9277 5.25446 12.4455 5.27875 13.7933 5.85349C18.4115 7.8246 21.4957 13.9079 23.147 22.8973C25.6605 36.5818 25.2153 56.0663 25.5957 67.3061C26.1502 83.8075 31.0112 97.6418 37.7017 96.553Z",
    fill: "#F7F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8717 96.5247L95.4266 88.6928C86.765 82.9738 80.536 76.4493 78.4678 65.3147C76.4966 54.7266 77.7433 34.7807 76.5533 23.6785C75.3633 12.5561 73.6998 6.67107 66.4104 4.16165C64.7064 3.57477 63.2817 3.32383 61.6182 3.14574C58.36 2.79361 52.4385 3.19026 52.4385 3.19026L11.0938 5.24637C11.0938 5.24637 12.6075 5.2747 13.9553 5.84944C18.5735 7.82055 21.6576 13.9039 23.309 22.8933C25.8225 36.5778 25.3772 56.0622 25.7577 67.302C26.3162 83.8075 31.1813 97.6134 37.8717 96.5247Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0417 96.4963L95.5925 88.6928C86.9309 82.9738 80.7019 76.4493 78.6336 65.3147C76.6625 54.7266 77.9091 34.7807 76.7192 23.6785C75.5292 12.5561 73.8617 6.67107 66.5762 4.16165C64.8723 3.57477 63.4476 3.32383 61.7841 3.14574C58.5258 2.79361 52.6044 3.19026 52.6044 3.19026L11.2637 5.24232C11.2637 5.24232 12.7734 5.27875 14.1212 5.85349C18.7393 7.8246 21.8235 13.9079 23.4749 22.8973C25.9883 36.5818 25.5431 56.0663 25.9236 67.3061C26.4821 83.8075 31.3512 97.5851 38.0417 96.4963Z",
    fill: "#F5F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0417 96.4963L95.5925 88.6928C86.9309 82.9738 80.7019 76.4493 78.6336 65.3147C76.6625 54.7266 77.9091 34.7807 76.7192 23.6785C75.5292 12.5561 73.8617 6.67107 66.5762 4.16165C64.8723 3.57477 63.4476 3.32383 61.7841 3.14574C58.5258 2.79361 52.6044 3.19026 52.6044 3.19026L11.2637 5.22208C11.2637 5.22208 12.7734 5.2747 14.1212 5.84944C18.7393 7.82055 21.8235 13.9039 23.4749 22.8933C25.9883 36.5778 25.5431 56.0622 25.9236 67.302C26.4821 83.8075 31.3512 97.5851 38.0417 96.4963Z",
    fill: "url(#paint4_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.264 74.0234L38.3382 80.4913C37.4761 80.6572 36.9175 81.3858 37.0754 82.1386C37.8808 85.9715 39.3258 95.0945 36.1607 96.673C36.104 96.7013 36.1283 96.7904 36.193 96.7823L95.4033 88.6793C95.4033 88.6752 100.135 87.3477 101.264 74.0234Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3425 80.4994C37.622 80.637 37.197 81.3858 37.3792 82.2357C38.2008 86.1213 39.6458 95.1714 36.4523 96.6487C36.3956 96.673 36.4118 96.7499 36.4564 96.7459L95.4116 88.6793C95.4116 88.6793 100.212 87.2424 101.272 74.0234L38.3425 80.4994Z",
    fill: "#F5F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3415 80.5075C37.7668 80.6208 37.4713 81.3898 37.6737 82.3288C38.5115 86.267 39.9605 95.2443 36.7347 96.6204C36.678 96.6447 36.6821 96.7054 36.7063 96.7054L95.4066 88.6793C95.4066 88.6793 100.276 87.1332 101.267 74.0234L38.3415 80.5075Z",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3416 80.5156C37.9085 80.6006 37.7466 81.3898 37.9692 82.426C38.8273 86.4168 40.2803 95.3293 37.014 96.5961C36.9614 96.6164 36.9493 96.6649 36.9574 96.669L95.4027 88.6793C95.4027 88.6793 100.341 87.0279 101.263 74.0234L38.3416 80.5156Z",
    fill: "#F3F5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3423 80.5235C38.0549 80.5802 38.0225 81.3937 38.2654 82.523C39.1396 86.5704 40.6008 95.4141 37.298 96.5717C37.2454 96.5919 37.2211 96.6284 37.209 96.6324L95.3993 88.6832C95.3993 88.6832 100.406 86.9225 101.26 74.0273L38.3423 80.5235Z",
    fill: "#F3F5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.347 80.5278C38.2013 80.5562 38.3025 81.39 38.5697 82.6123C39.4601 86.7124 40.9293 95.4994 37.5902 96.5396C37.5376 96.5558 37.5011 96.5801 37.4688 96.5882L95.4041 88.6754C95.4041 88.6754 100.48 86.8055 101.265 74.0195L38.347 80.5278Z",
    fill: "#F2F4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.264 74.0234L38.346 80.5358C38.346 80.5358 42.4096 95.6328 37.7227 96.5516L95.403 88.6752C95.403 88.6752 100.547 86.7001 101.264 74.0234Z",
    fill: "#F1F3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0729 28.1638L64.0282 26.3384C65.4812 26.2129 66.5983 24.6385 66.5255 23.149L66.5012 22.5298C66.4283 21.0322 65.1696 19.8787 63.7003 19.9677L33.4172 21.526C31.8914 21.6191 30.8107 23.3393 30.9402 25.0109L30.9564 25.2375C31.1223 26.7594 32.5673 28.2933 34.0729 28.1638Z",
    fill: "#0095CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0806 28.1556L64.0278 26.3342C65.4768 26.2088 66.5979 24.6383 66.525 23.1489L66.5008 22.5337C66.4279 21.0361 65.1691 19.8826 63.704 19.9716L33.429 21.5299C31.9031 21.623 30.8224 23.3391 30.9519 25.0067L30.9681 25.2414C31.1341 26.7592 32.575 28.2851 34.0806 28.1556Z",
    fill: "#0196CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0924 28.1476L64.0314 26.3263C65.4804 26.2008 66.5975 24.6344 66.5247 23.145L66.5004 22.5297C66.4275 21.0362 65.1688 19.8787 63.7036 19.9677L33.4367 21.526C31.9108 21.6191 30.8342 23.3271 30.9637 24.9906L30.9799 25.2334C31.1458 26.7593 32.5867 28.2771 34.0924 28.1476Z",
    fill: "#0297CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1018 28.1398L64.0328 26.3185C65.4818 26.193 66.5989 24.6307 66.526 23.1453L66.5017 22.53C66.4289 21.0365 65.1741 19.879 63.709 19.972L33.4542 21.5263C31.9324 21.6194 30.8517 23.3233 30.9812 24.9828L30.9974 25.2337C31.1634 26.7556 32.6002 28.2693 34.1018 28.1398Z",
    fill: "#0397CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1137 28.1317L64.0325 26.3104C65.4815 26.1849 66.5986 24.6266 66.5217 23.1412L66.4974 22.53C66.4246 21.0365 65.1699 19.879 63.7047 19.972L33.458 21.5263C31.9362 21.6194 30.8595 23.3152 30.9891 24.9747L31.0053 25.2337C31.1752 26.7556 32.6121 28.2612 34.1137 28.1317Z",
    fill: "#0498CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1214 28.1238L64.0321 26.3024C65.477 26.1769 66.5941 24.6227 66.5213 23.1373L66.497 22.5261C66.4241 21.0326 65.1694 19.875 63.7083 19.9681L33.4697 21.5224C31.9479 21.6155 30.8713 23.3073 31.0008 24.9627L31.017 25.2339C31.187 26.7517 32.6198 28.2533 34.1214 28.1238Z",
    fill: "#0599CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1332 28.1154L64.0358 26.294C65.4808 26.1686 66.5979 24.6184 66.521 23.133L66.4967 22.5218C66.4238 21.0283 65.1691 19.8748 63.708 19.9638L33.4775 21.518C31.9597 21.6111 30.879 23.2949 31.0086 24.9462L31.0248 25.2255C31.2028 26.7514 32.6316 28.2449 34.1332 28.1154Z",
    fill: "#069ACD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1408 28.107L64.0353 26.2897C65.4802 26.1642 66.5933 24.6181 66.5204 23.1367L66.4962 22.5296C66.4233 21.0401 65.1726 19.8826 63.7115 19.9716L33.4891 21.5258C31.9713 21.6189 30.8947 23.2986 31.0242 24.9459L31.0445 25.2333C31.2145 26.7471 32.6432 28.2365 34.1408 28.107Z",
    fill: "#079BCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1543 28.099L64.0407 26.2817C65.4857 26.1563 66.5987 24.6142 66.5218 23.1328L66.4975 22.5257C66.4247 21.0362 65.174 19.8787 63.7129 19.9677L33.5067 21.5219C31.9889 21.615 30.9123 23.2866 31.0418 24.9339L31.062 25.2294C31.228 26.7472 32.6567 28.2286 34.1543 28.099Z",
    fill: "#089CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1626 28.0911L64.0409 26.2738C65.4818 26.1483 66.5949 24.6143 66.522 23.1289L66.4978 22.5218C66.4249 21.0323 65.1742 19.8748 63.7171 19.9638L33.515 21.518C31.9972 21.6111 30.9206 23.2787 31.0542 24.9219L31.0744 25.2255C31.2403 26.7433 32.6691 28.2206 34.1626 28.0911Z",
    fill: "#099CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1737 28.0832L64.0439 26.2658C65.4848 26.1404 66.5979 24.6104 66.521 23.1291L66.5007 22.526C66.4279 21.0365 65.1772 19.879 63.7201 19.972L33.5261 21.5263C32.0123 21.6194 30.9357 23.2788 31.0652 24.9221L31.0855 25.2337C31.2555 26.7434 32.6761 28.2127 34.1737 28.0832Z",
    fill: "#0A9DCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1818 28.0752L64.044 26.2579C65.4849 26.1324 66.5939 24.6065 66.521 23.1252L66.5008 22.5221C66.428 21.0326 65.1813 19.875 63.7243 19.9681L33.5383 21.5183C32.0246 21.6114 30.9479 23.2668 31.0815 24.902L31.1017 25.2217C31.2677 26.7395 32.6883 28.2047 34.1818 28.0752Z",
    fill: "#0B9ECF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1934 28.0667L64.0475 26.2494C65.4843 26.1239 66.5974 24.602 66.5245 23.1207L66.5043 22.5216C66.4314 21.0362 65.1848 19.8787 63.7277 19.9677L33.5539 21.5179C32.0402 21.611 30.9636 23.2583 31.0971 24.8935L31.1174 25.2213C31.2793 26.7391 32.6999 28.1962 34.1934 28.0667Z",
    fill: "#0C9FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2031 28.0586L64.049 26.2413C65.4859 26.1158 66.5949 24.598 66.522 23.1207L66.5018 22.5216C66.4289 21.0362 65.1823 19.8787 63.7293 19.9677L33.5636 21.5179C32.0539 21.611 30.9772 23.2542 31.1108 24.8854L31.131 25.2213C31.2929 26.7351 32.7136 28.1881 34.2031 28.0586Z",
    fill: "#0DA0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2149 28.0505L64.0487 26.2372C65.4856 26.1117 66.5946 24.598 66.5217 23.1207L66.5015 22.5216C66.4286 21.0362 65.182 19.8787 63.729 19.9677L33.5714 21.5179C32.0617 21.611 30.985 23.2461 31.1186 24.8773L31.1388 25.2213C31.3088 26.7351 32.7214 28.18 34.2149 28.0505Z",
    fill: "#0EA0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2226 28.0424L64.0484 26.2291C65.4852 26.1037 66.5902 24.594 66.5173 23.1166L66.4971 22.5216C66.4242 21.0362 65.1816 19.8787 63.7286 19.9677L33.5791 21.5179C32.0694 21.611 30.9968 23.2421 31.1304 24.8692L31.1506 25.2213C31.3206 26.731 32.7332 28.1719 34.2226 28.0424Z",
    fill: "#0FA1D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2342 28.0344L64.0518 26.2212C65.4846 26.0957 66.5936 24.59 66.5208 23.1127L66.5005 22.5177C66.4277 21.0323 65.1851 19.8748 63.7361 19.9638L33.5947 21.514C32.085 21.6071 31.0124 23.2301 31.146 24.8531L31.1662 25.2174C31.3322 26.7312 32.7447 28.1639 34.2342 28.0344Z",
    fill: "#10A2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2425 28.0266L64.052 26.2134C65.4848 26.0879 66.5898 24.5863 66.5169 23.113L66.4967 22.518C66.4238 21.0366 65.1813 19.875 63.7323 19.9681L33.603 21.5183C32.0973 21.6114 31.0207 23.2263 31.1583 24.8494L31.1826 25.2217C31.3445 26.7274 32.7571 28.1561 34.2425 28.0266Z",
    fill: "#11A3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2554 28.0185L64.0569 26.2053C65.4897 26.0798 66.5946 24.5822 66.5218 23.1089L66.5015 22.518C66.4287 21.0366 65.1861 19.875 63.7411 19.9681L33.62 21.5183C32.1143 21.6114 31.0417 23.2223 31.1753 24.8413L31.1996 25.2217C31.3615 26.7274 32.77 28.148 34.2554 28.0185Z",
    fill: "#12A4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2639 28.0101L64.0572 26.1969C65.49 26.0714 66.5909 24.5819 66.5181 23.1046L66.4978 22.5137C66.425 21.0323 65.1865 19.8748 63.7375 19.9638L33.6244 21.5099C32.1187 21.603 31.0461 23.2058 31.1838 24.8248L31.208 25.2133C31.374 26.7271 32.7785 28.1397 34.2639 28.0101Z",
    fill: "#13A5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2754 28.0019L64.0607 26.1927C65.4894 26.0672 66.5944 24.5818 66.5215 23.1085L66.5013 22.5176C66.4284 21.0362 65.1899 19.8787 63.745 19.9677L33.64 21.5138C32.1384 21.6069 31.0617 23.2057 31.1993 24.8206L31.2236 25.2173C31.3855 26.7229 32.79 28.1314 34.2754 28.0019Z",
    fill: "#14A5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2833 27.9938L64.0604 26.1846C65.4892 26.0591 66.5901 24.5778 66.5172 23.1045L66.497 22.5176C66.4241 21.0362 65.1856 19.8787 63.7407 19.9677L33.6438 21.5138C32.1422 21.6069 31.0696 23.1976 31.2072 24.8085L31.2315 25.2132C31.4015 26.7229 32.8019 28.1233 34.2833 27.9938Z",
    fill: "#15A6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2947 27.9858L64.0638 26.1766C65.4925 26.0512 66.5934 24.5738 66.5206 23.1006L66.5003 22.5137C66.4275 21.0364 65.189 19.8747 63.7481 19.9638L33.6633 21.5099C32.1617 21.603 31.0891 23.1896 31.2267 24.7964L31.251 25.2093C31.4129 26.719 32.8133 28.1154 34.2947 27.9858Z",
    fill: "#16A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3045 27.9776L64.0655 26.1684C65.4942 26.0429 66.5951 24.5697 66.5182 23.1004L66.498 22.5176C66.4251 21.0403 65.1907 19.8786 63.7457 19.9677L33.6691 21.5138C32.1675 21.6069 31.0989 23.1854 31.2365 24.7923L31.2608 25.2132C31.4268 26.7188 32.8231 28.1071 34.3045 27.9776Z",
    fill: "#17A8D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.316 27.9699L64.0689 26.1607C65.4936 26.0353 66.5945 24.566 66.5217 23.0968L66.5014 22.514C66.4286 21.0366 65.1941 19.875 63.7532 19.9681L33.6846 21.5143C32.1871 21.6073 31.1145 23.1818 31.2521 24.7846L31.2764 25.2136C31.4383 26.7152 32.8347 28.0995 34.316 27.9699Z",
    fill: "#18A9D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3247 27.9616L64.0654 26.1524C65.4901 26.0309 66.591 24.5617 66.5141 23.0925L66.4939 22.5097C66.421 21.0323 65.1866 19.8748 63.7457 19.9638L33.6852 21.5099C32.1876 21.603 31.115 23.1694 31.2567 24.7681L31.281 25.2053C31.455 26.715 32.8474 28.0911 34.3247 27.9616Z",
    fill: "#19A9D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3356 27.9535L64.0683 26.1443C65.493 26.0228 66.5898 24.5577 66.517 23.0884L66.4967 22.5097C66.4239 21.0323 65.1894 19.8748 63.7525 19.9638L33.7002 21.5099C32.2026 21.603 31.1341 23.1653 31.2717 24.76L31.296 25.2093C31.466 26.7109 32.8583 28.083 34.3356 27.9535Z",
    fill: "#1AAAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3438 27.9452L64.0683 26.1401C65.489 26.0186 66.5899 24.5575 66.517 23.0923L66.4968 22.5135C66.4239 21.0403 65.1895 19.8786 63.7526 19.9677L33.7124 21.5098C32.2189 21.6029 31.1463 23.1571 31.2879 24.7518L31.3163 25.2091C31.4782 26.7108 32.8705 28.0747 34.3438 27.9452Z",
    fill: "#1BABD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3555 27.9373L64.0719 26.1321C65.4926 26.0107 66.5895 24.5576 66.5166 23.0884L66.4964 22.5096C66.4235 21.0364 65.1931 19.8747 63.7562 19.9638L33.7241 21.5059C32.2306 21.599 31.158 23.1491 31.2997 24.7398L31.328 25.2052C31.4899 26.7068 32.8782 28.0668 34.3555 27.9373Z",
    fill: "#1CACD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3652 27.9292L64.0735 26.124C65.4942 26.0026 66.591 24.5536 66.5182 23.0844L66.4979 22.5096C66.4251 21.0364 65.1946 19.8747 63.7578 19.9638L33.7338 21.5059C32.2403 21.599 31.1717 23.141 31.3134 24.7317L31.3417 25.2052C31.5077 26.7068 32.8919 28.0587 34.3652 27.9292Z",
    fill: "#1DADD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3767 27.9211L64.077 26.1159C65.4977 25.9945 66.5905 24.5496 66.5176 23.0844L66.5014 22.5096C66.4286 21.0364 65.1981 19.8747 63.7653 19.9638L33.7494 21.5059C32.2559 21.599 31.1873 23.137 31.329 24.7195L31.3573 25.2012C31.5192 26.7028 32.9035 28.0506 34.3767 27.9211Z",
    fill: "#1EAED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3843 27.9129L64.0764 26.1077C65.493 25.9863 66.5899 24.5454 66.517 23.0802L66.5009 22.5095C66.428 21.0362 65.1976 19.8787 63.7648 19.9677L33.761 21.5098C32.2715 21.6029 31.203 23.1328 31.3446 24.7154L31.373 25.2051C31.5308 26.7027 32.915 28.0424 34.3843 27.9129Z",
    fill: "#1FAED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.396 27.9049L64.0801 26.0997C65.4967 25.9783 66.5895 24.5415 66.5166 23.0763L66.5004 22.5056C66.4276 21.0364 65.2012 19.8747 63.7684 19.9638L33.7727 21.5059C32.2832 21.599 31.2147 23.1208 31.3563 24.7034L31.3847 25.2012C31.5466 26.6988 32.9227 28.0344 34.396 27.9049Z",
    fill: "#20AFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4044 27.8967L64.0803 26.0955C65.4969 25.9741 66.5898 24.5413 66.5169 23.0802L66.5007 22.5095C66.4278 21.0403 65.2015 19.8786 63.7687 19.9677L33.781 21.5098C32.2916 21.6029 31.2231 23.1207 31.3688 24.6992L31.3971 25.2051C31.559 26.6986 32.9351 28.0262 34.4044 27.8967Z",
    fill: "#21B0D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4173 27.8886L64.0852 26.0874C65.5018 25.966 66.5906 24.5373 66.5177 23.0761L66.5015 22.5095C66.4287 21.0403 65.2023 19.8786 63.7736 19.9677L33.794 21.5098C32.3086 21.6029 31.2401 23.1126 31.3817 24.6911L31.4101 25.2051C31.572 26.6946 32.9481 28.0181 34.4173 27.8886Z",
    fill: "#22B1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4258 27.8806L64.0816 26.0795C65.4941 25.9581 66.5869 24.5334 66.5141 23.0722L66.4979 22.5056C66.4251 21.0364 65.1987 19.8747 63.7699 19.9638L33.7985 21.5018C32.3131 21.5949 31.2445 23.1006 31.3902 24.671L31.4186 25.1931C31.5845 26.6947 32.9607 28.0101 34.4258 27.8806Z",
    fill: "#23B2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4374 27.8727L64.085 26.0715C65.4976 25.9501 66.5864 24.5295 66.5135 23.0683L66.4973 22.5017C66.4245 21.0325 65.2021 19.8708 63.7734 19.9599L33.8141 21.4979C32.3287 21.591 31.2602 23.0886 31.4059 24.659L31.4342 25.1932C31.6001 26.6948 32.9722 28.0022 34.4374 27.8727Z",
    fill: "#23B2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4451 27.8643L64.0847 26.0632C65.4972 25.9417 66.586 24.5251 66.5132 23.068L66.497 22.5054C66.4241 21.0403 65.2018 19.8786 63.773 19.9677L33.8218 21.5057C32.3364 21.5988 31.2719 23.0923 31.4176 24.6587L31.45 25.2011C31.6119 26.6905 32.98 27.9938 34.4451 27.8643Z",
    fill: "#24B3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4568 27.8563L64.0883 26.0552C65.4968 25.9338 66.5855 24.5253 66.5127 23.0641L66.4965 22.5015C66.4236 21.0364 65.2013 19.8747 63.7766 19.9638L33.8335 21.5018C32.3521 21.5949 31.2836 23.0803 31.4293 24.6467L31.4617 25.1971C31.6236 26.6907 32.9916 27.9858 34.4568 27.8563Z",
    fill: "#25B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4665 27.8484L64.0898 26.0473C65.4983 25.9258 66.5871 24.5214 66.5143 23.0602L66.4981 22.4976C66.4252 21.0325 65.2029 19.8708 63.7782 19.9599L33.8432 21.4979C32.3618 21.591 31.2973 23.0724 31.443 24.6347L31.4754 25.1932C31.6373 26.6868 33.0053 27.9779 34.4665 27.8484Z",
    fill: "#26B5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4781 27.84L64.0933 26.0429C65.5018 25.9215 66.5865 24.5211 66.5177 23.064L66.5015 22.5054C66.4287 21.0403 65.2104 19.8786 63.7857 19.9677L33.8588 21.5057C32.3774 21.5988 31.3129 23.0721 31.4586 24.6304L31.491 25.197C31.6529 26.6865 33.0169 27.9695 34.4781 27.84Z",
    fill: "#27B6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4857 27.832L64.0928 26.035C65.5014 25.9135 66.5861 24.5172 66.5132 23.0601L66.497 22.5015C66.4242 21.0364 65.2059 19.8747 63.7852 19.9638L33.8705 21.5018C32.3931 21.5949 31.3246 23.0641 31.4703 24.6184L31.5027 25.1931C31.6646 26.6826 33.0245 27.9616 34.4857 27.832Z",
    fill: "#28B6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4973 27.8239L64.0964 26.0269C65.5008 25.9054 66.5896 24.5131 66.5167 23.056L66.5006 22.5015C66.4277 21.0404 65.2094 19.8747 63.7888 19.9638L33.8821 21.4978C32.4048 21.5908 31.3403 23.052 31.486 24.6062L31.5184 25.189C31.6762 26.6825 33.0362 27.9534 34.4973 27.8239Z",
    fill: "#29B7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5051 27.8154L64.0961 26.0184C65.5006 25.8969 66.5853 24.5087 66.5124 23.0556L66.4962 22.5011C66.4234 21.04 65.2051 19.8784 63.7885 19.9634L33.8899 21.4974C32.4126 21.5904 31.3481 23.0475 31.4938 24.5977L31.5262 25.1886C31.6921 26.6781 33.048 27.945 34.5051 27.8154Z",
    fill: "#2AB8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5174 27.8117L64.1002 26.0146C65.5047 25.8932 66.5894 24.5089 66.5166 23.0559L66.5004 22.5014C66.4275 21.0403 65.2133 19.8786 63.7926 19.9677L33.9021 21.5017C32.4289 21.5948 31.3603 23.0438 31.5101 24.5899L31.5425 25.1889C31.7044 26.6784 33.0603 27.9371 34.5174 27.8117Z",
    fill: "#2BB9DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5265 27.8036L64.0972 26.0065C65.5017 25.8851 66.5823 24.5049 66.5095 23.0519L66.4933 22.5014C66.4204 21.0403 65.2062 19.8786 63.7896 19.9677L33.9112 21.5017C32.438 21.5948 31.3735 23.0397 31.5192 24.5818L31.5516 25.1889C31.7175 26.6743 33.0694 27.929 34.5265 27.8036Z",
    fill: "#2CBADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5387 27.7955L64.1014 26.0024C65.5018 25.881 66.5865 24.5049 66.5137 23.0519L66.4975 22.5014C66.4246 21.0403 65.2104 19.8786 63.7938 19.9677L33.9235 21.5017C32.4503 21.5948 31.3858 23.0316 31.5355 24.5737L31.5679 25.1889C31.7298 26.6743 33.0817 27.9209 34.5387 27.7955Z",
    fill: "#2DBBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5459 27.7874L64.1004 25.9943C65.5009 25.8729 66.5815 24.5008 66.5087 23.0518L66.4925 22.5014C66.4196 21.0443 65.2054 19.8786 63.7928 19.9677L33.9307 21.5017C32.4574 21.5948 31.397 23.0235 31.5427 24.5656L31.5751 25.1929C31.7451 26.6703 33.0929 27.9128 34.5459 27.7874Z",
    fill: "#2EBBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5581 27.7793L64.1046 25.9862C65.505 25.8648 66.5857 24.5008 66.5128 23.0478L66.4966 22.5014C66.4238 21.0443 65.2136 19.8786 63.797 19.9677L33.9429 21.5017C32.4737 21.5948 31.4092 23.0195 31.559 24.5575L31.5954 25.1929C31.7573 26.6703 33.1051 27.9047 34.5581 27.7793Z",
    fill: "#2FBCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5659 27.7709L64.1043 25.9779C65.5007 25.8565 66.5813 24.4965 66.5085 23.0435L66.4923 22.4971C66.4194 21.04 65.2093 19.8784 63.7967 19.9634L33.9507 21.4974C32.4815 21.5904 31.417 23.0071 31.5668 24.541L31.6032 25.1846C31.7692 26.666 33.117 27.8964 34.5659 27.7709Z",
    fill: "#30BDDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5794 27.7627L64.1096 25.9697C65.506 25.8482 66.5867 24.4923 66.5138 23.0433L66.4976 22.501C66.4248 21.0439 65.2146 19.8823 63.802 19.9673L33.9682 21.4972C32.499 21.5903 31.4386 23.0029 31.5883 24.5328L31.6247 25.1845C31.7826 26.6658 33.1263 27.8882 34.5794 27.7627Z",
    fill: "#31BEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.587 27.755L64.1092 25.962C65.5056 25.8406 66.5822 24.4887 66.5093 23.0397L66.4972 22.4974C66.4243 21.0403 65.2141 19.8786 63.8056 19.9677L33.9799 21.4976C32.5147 21.5907 31.4502 22.9952 31.6 24.5251L31.6364 25.1849C31.7983 26.6622 33.138 27.8805 34.587 27.755Z",
    fill: "#32BFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5993 27.747L64.1134 25.954C65.5098 25.8326 66.5864 24.4848 66.5135 23.0358L66.5014 22.4934C66.4285 21.0404 65.2224 19.8747 63.8098 19.9638L33.9922 21.4937C32.527 21.5868 31.4625 22.9872 31.6163 24.5131L31.6528 25.1809C31.8106 26.6623 33.1503 27.8725 34.5993 27.747Z",
    fill: "#33BFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6064 27.7387L64.1124 25.9497C65.5047 25.8283 66.5814 24.4845 66.5085 23.0396L66.4964 22.5012C66.4235 21.0482 65.2174 19.8825 63.8089 19.9716L33.9993 21.5015C32.5341 21.5946 31.4737 22.9869 31.6235 24.5128L31.6599 25.1888C31.8218 26.658 33.1615 27.8641 34.6064 27.7387Z",
    fill: "#34C0DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6188 27.7307L64.1166 25.9417C65.509 25.8203 66.5856 24.4806 66.5127 23.0357L66.5006 22.4973C66.4277 21.0443 65.2216 19.8786 63.8131 19.9677L34.0116 21.4976C32.5465 21.5907 31.486 22.979 31.6398 24.4968L31.6763 25.1808C31.8341 26.6581 33.1698 27.8562 34.6188 27.7307Z",
    fill: "#35C1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6275 27.7223L64.1173 25.9334C65.5096 25.8119 66.5822 24.4763 66.5134 23.0313L66.5012 22.493C66.4284 21.04 65.2222 19.8784 63.8178 19.9634L34.0285 21.4933C32.5673 21.5864 31.5069 22.9666 31.6567 24.4844L31.6931 25.1765C31.8509 26.6579 33.1826 27.8478 34.6275 27.7223Z",
    fill: "#36C2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6401 27.7143L64.1177 25.9253C65.5101 25.8039 66.5826 24.4722 66.5098 23.0273L66.4976 22.493C66.4248 21.04 65.2227 19.8784 63.8142 19.9634L34.033 21.4933C32.5718 21.5824 31.5114 22.9625 31.6652 24.4763L31.7016 25.1765C31.8635 26.6538 33.1952 27.8397 34.6401 27.7143Z",
    fill: "#37C3DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6478 27.7061L64.1173 25.9172C65.5056 25.7957 66.5782 24.4722 66.5094 23.0273L66.4972 22.493C66.4244 21.044 65.2223 19.8784 63.8178 19.9634L34.0447 21.4933C32.5836 21.5823 31.5231 22.9544 31.6769 24.4682L31.7134 25.1805C31.8753 26.6538 33.2069 27.8316 34.6478 27.7061Z",
    fill: "#38C4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6595 27.6985L64.1209 25.9095C65.5092 25.7881 66.5818 24.4686 66.5089 23.0236L66.4968 22.4894C66.4239 21.0404 65.2218 19.8747 63.8174 19.9638L34.0524 21.4897C32.5953 21.5787 31.5349 22.9467 31.6887 24.4564L31.7291 25.1769C31.891 26.6502 33.2186 27.8239 34.6595 27.6985Z",
    fill: "#39C4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.667 27.6904L64.1204 25.9014C65.5087 25.78 66.5772 24.4645 66.5084 23.0196L66.4962 22.4894C66.4234 21.0404 65.2213 19.8747 63.8209 19.9638L34.068 21.4897C32.6109 21.5787 31.5505 22.9386 31.7043 24.4443L31.7448 25.1728C31.9026 26.6502 33.2261 27.8158 34.667 27.6904Z",
    fill: "#3AC5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6795 27.6821L64.1247 25.8972C65.513 25.7758 66.5815 24.4644 66.5087 23.0235L66.4966 22.4933C66.4237 21.0443 65.2216 19.8786 63.8212 19.9677L34.0764 21.4936C32.6193 21.5826 31.5589 22.9385 31.7167 24.4401L31.7572 25.1768C31.9151 26.646 33.2386 27.8076 34.6795 27.6821Z",
    fill: "#3BC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6884 27.6736L64.1256 25.8887C65.5098 25.7673 66.5824 24.46 66.5095 23.0191L66.4974 22.4929C66.4245 21.0439 65.2265 19.8823 63.8261 19.9673L34.0894 21.4932C32.6323 21.5822 31.5759 22.93 31.7297 24.4316L31.7702 25.1764C31.928 26.6456 33.2516 27.7991 34.6884 27.6736Z",
    fill: "#3CC7E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7008 27.6657L64.1299 25.8807C65.5141 25.7593 66.5827 24.456 66.5098 23.0151L66.4977 22.489C66.4248 21.044 65.2268 19.8784 63.8263 19.9634L34.0978 21.4892C32.6447 21.5783 31.5843 22.922 31.7421 24.4196L31.7826 25.1724C31.9445 26.6417 33.264 27.7911 34.7008 27.6657Z",
    fill: "#3DC8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7078 27.6576L64.1288 25.8726C65.513 25.7512 66.5815 24.452 66.5087 23.0151L66.4965 22.489C66.4237 21.044 65.2256 19.8784 63.8293 19.9634L34.1088 21.4892C32.6557 21.5783 31.5994 22.914 31.7532 24.4075L31.7936 25.1684C31.9555 26.6417 33.271 27.783 34.7078 27.6576Z",
    fill: "#3EC8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7201 27.6495L64.133 25.8646C65.5132 25.7431 66.5817 24.4479 66.5089 23.0111L66.4967 22.489C66.4239 21.044 65.2258 19.8784 63.8294 19.9634L34.1211 21.4892C32.6681 21.5783 31.6117 22.9059 31.7695 24.3994L31.81 25.1684C31.9679 26.6376 33.2833 27.775 34.7201 27.6495Z",
    fill: "#3FC9E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7277 27.6418L64.1325 25.8569C65.5127 25.7354 66.5812 24.4443 66.5084 23.0075L66.4963 22.4853C66.4234 21.0404 65.2294 19.8747 63.833 19.9638L34.1328 21.4897C32.6838 21.5787 31.6233 22.9022 31.7812 24.3917L31.8217 25.1688C31.9795 26.638 33.2949 27.7673 34.7277 27.6418Z",
    fill: "#40CAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7416 27.6337L64.1343 25.8528C65.5144 25.7314 66.5789 24.4443 66.5061 23.0075L66.4939 22.4853C66.4211 21.0404 65.2271 19.8747 63.8307 19.9638L34.1385 21.4856C32.6896 21.5747 31.6332 22.8901 31.791 24.3795L31.8315 25.1648C31.9974 26.634 33.3088 27.7592 34.7416 27.6337Z",
    fill: "#41CBE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7493 27.6255L64.1338 25.8446C65.514 25.7231 66.5785 24.4441 66.5057 23.0073L66.4935 22.4892C66.4207 21.0483 65.2267 19.8786 63.8343 19.9677L34.1503 21.4895C32.7013 21.5785 31.6449 22.8899 31.8027 24.3753L31.8432 25.1686C32.0092 26.6338 33.3205 27.7509 34.7493 27.6255Z",
    fill: "#42CCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7615 27.6171L64.1379 25.8362C65.5141 25.7148 66.5786 24.4398 66.5097 23.003L66.4976 22.4849C66.4248 21.044 65.2308 19.8784 63.8425 19.9634L34.1665 21.4852C32.7175 21.5742 31.6611 22.8775 31.823 24.3589L31.8676 25.1643C32.0214 26.6295 33.3287 27.7426 34.7615 27.6171Z",
    fill: "#43CDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7685 27.6091L64.1369 25.8283C65.513 25.7068 66.5775 24.4359 66.5047 22.9991L66.4925 22.481C66.4197 21.0401 65.2297 19.8745 63.8374 19.9594L34.1736 21.4813C32.7286 21.5703 31.6722 22.8696 31.8301 24.3469L31.8746 25.1604C32.0365 26.6297 33.3398 27.7346 34.7685 27.6091Z",
    fill: "#44CDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7807 27.6009L64.141 25.82C65.5171 25.6986 66.5776 24.4318 66.5088 22.999L66.4966 22.4849C66.4238 21.044 65.2338 19.8784 63.8455 19.9634L34.1898 21.4852C32.7449 21.5742 31.6885 22.8654 31.8504 24.3427L31.8949 25.1643C32.0487 26.6255 33.352 27.7264 34.7807 27.6009Z",
    fill: "#45CEE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7899 27.593L64.1421 25.8121C65.5182 25.6907 66.5787 24.4278 66.5058 22.995L66.4937 22.481C66.4208 21.0401 65.2309 19.8745 63.8426 19.9594L34.195 21.4813C32.75 21.5703 31.6977 22.8574 31.8555 24.3307L31.9 25.1604C32.0619 26.6256 33.3652 27.7144 34.7899 27.593Z",
    fill: "#46CFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7898 27.5944L64.142 25.8135C65.5181 25.6921 66.5745 24.2715 66.5057 22.8387L66.4976 22.5918C66.4247 21.1509 65.2348 19.88 63.8465 19.965L34.1989 21.4868C32.7539 21.5759 31.7016 22.863 31.8594 24.3362L31.9039 25.166C32.0618 26.6271 33.3651 27.7159 34.7898 27.5944Z",
    fill: "url(#paint5_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.6372 24.758C31.787 26.4418 33.2562 27.7046 34.9278 27.5872C36.6034 27.4698 37.8581 26.0168 37.7327 24.325C37.6072 22.621 36.1258 21.3298 34.4299 21.4513C32.7341 21.5767 31.4874 23.0622 31.6372 24.758Z",
    fill: "url(#paint6_radial_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2629 33.6701L55.9031 32.8201C56.5183 32.7635 56.9878 32.0997 56.9554 31.4764L56.9433 31.2173C56.9109 30.594 56.3807 30.1205 55.7655 30.165L43.1171 30.9057C42.4817 30.9502 41.996 31.6626 42.0162 32.3587V32.4518C42.0567 33.0873 42.6274 33.7268 43.2629 33.6701Z",
    fill: "#0095CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2666 33.6662L55.9068 32.8162C56.522 32.7595 56.9916 32.0958 56.9592 31.4725L56.947 31.2134C56.9147 30.5942 56.3844 30.1166 55.7692 30.1611L43.125 30.9018C42.4895 30.9463 42.0038 31.6586 42.024 32.3508V32.4479C42.0605 33.0874 42.6312 33.7269 43.2666 33.6662Z",
    fill: "#0196CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2703 33.662L55.9065 32.812C56.5217 32.7554 56.9912 32.0916 56.9588 31.4723L56.9467 31.2173C56.9143 30.5981 56.3841 30.1205 55.7689 30.165L43.1286 30.9057C42.4932 30.9502 42.0116 31.6585 42.0277 32.3506V32.4518C42.0642 33.0873 42.6349 33.7227 43.2703 33.662Z",
    fill: "#0297CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2744 33.6576L55.9065 32.8077C56.5217 32.751 56.9912 32.0913 56.9548 31.4679L56.9426 31.213C56.9102 30.5937 56.38 30.1201 55.7648 30.1606L43.1286 30.9013C42.4932 30.9458 42.0116 31.6541 42.0277 32.3422V32.4474C42.0723 33.0869 42.643 33.7183 43.2744 33.6576Z",
    fill: "#0397CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2782 33.6575L55.9063 32.8075C56.5174 32.7509 56.991 32.0911 56.9546 31.4719L56.9424 31.2169C56.91 30.5976 56.3798 30.124 55.7687 30.1645L43.1365 30.9052C42.5011 30.9497 42.0194 31.654 42.0397 32.3421V32.4513C42.0761 33.0827 42.6468 33.7141 43.2782 33.6575Z",
    fill: "#0498CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2822 33.6534L55.9063 32.8035C56.5174 32.7468 56.9869 32.0911 56.9546 31.4719L56.9424 31.2169C56.91 30.5976 56.3798 30.124 55.7687 30.1645L43.1365 30.9052C42.5051 30.9497 42.0194 31.6499 42.0397 32.338V32.4513C42.0842 33.0827 42.6508 33.7101 43.2822 33.6534Z",
    fill: "#0599CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2881 33.6495L55.9081 32.7996C56.5192 32.7429 56.9888 32.0872 56.9564 31.4679L56.9442 31.213C56.9119 30.5937 56.3816 30.1201 55.7705 30.1606L43.1424 30.9013C42.511 30.9458 42.0253 31.646 42.0455 32.3301V32.4474C42.0901 33.0829 42.6567 33.7062 43.2881 33.6495Z",
    fill: "#069ACD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2918 33.6455L55.9077 32.7955C56.5189 32.7388 56.9884 32.0872 56.956 31.4679L56.9439 31.213C56.9115 30.5937 56.3853 30.1201 55.7701 30.1606L43.1461 30.9013C42.5147 30.9458 42.033 31.642 42.0492 32.326V32.4434C42.0937 33.0829 42.6644 33.7021 43.2918 33.6455Z",
    fill: "#079BCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2997 33.6414L55.9116 32.7915C56.5227 32.7348 56.9922 32.0832 56.9558 31.4639L56.9437 31.213C56.9113 30.5937 56.3851 30.1201 55.774 30.1606L43.154 30.9013C42.5226 30.9458 42.0409 31.6379 42.0612 32.322V32.4434C42.1016 33.0829 42.6683 33.7021 43.2997 33.6414Z",
    fill: "#089CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3036 33.6372L55.9114 32.7913C56.5226 32.7347 56.9921 32.0871 56.9557 31.4678L56.9435 31.2169C56.9111 30.5976 56.385 30.124 55.7738 30.1645L43.1579 30.9052C42.5265 30.9497 42.0448 31.6418 42.0651 32.3218V32.4473C42.1055 33.0787 42.6722 33.698 43.3036 33.6372Z",
    fill: "#099CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3075 33.6333L55.9113 32.7874C56.5224 32.7308 56.9879 32.0832 56.9555 31.4639L56.9434 31.213C56.911 30.5937 56.3848 30.1201 55.7737 30.1606L43.1618 30.9013C42.5304 30.9458 42.0487 31.6339 42.069 32.3139V32.4434C42.1094 33.0788 42.6761 33.694 43.3075 33.6333Z",
    fill: "#0A9DCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3114 33.6335L55.9111 32.7876C56.5223 32.731 56.9878 32.0874 56.9554 31.4681L56.9432 31.2172C56.9109 30.5979 56.3847 30.1244 55.7735 30.1689L43.1657 30.9096C42.5343 30.9541 42.0526 31.6381 42.0729 32.3222V32.4557C42.1174 33.079 42.68 33.6902 43.3114 33.6335Z",
    fill: "#0B9ECF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3152 33.6296L55.9109 32.7837C56.522 32.727 56.9875 32.0835 56.9551 31.4642L56.943 31.2133C56.9106 30.594 56.3844 30.1205 55.7733 30.165L43.1695 30.9057C42.5381 30.9502 42.0605 31.6342 42.0807 32.3142V32.4518C42.1212 33.0792 42.6878 33.6863 43.3152 33.6296Z",
    fill: "#0C9FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3186 33.6256L55.9143 32.7796C56.5215 32.723 56.991 32.0835 56.9586 31.4642L56.9505 31.2133C56.9181 30.5981 56.3919 30.1205 55.7848 30.165L43.1851 30.9057C42.5577 30.9502 42.0761 31.6302 42.0963 32.3101V32.4518C42.1287 33.0792 42.6913 33.6822 43.3186 33.6256Z",
    fill: "#0DA0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3227 33.6217L55.9143 32.7757C56.5215 32.7191 56.991 32.0796 56.9545 31.4603L56.9465 31.2094C56.9141 30.5942 56.3879 30.1166 55.7808 30.1611L43.1851 30.8977C42.5577 30.9422 42.0761 31.6222 42.0963 32.2981V32.4438C42.1327 33.0753 42.6953 33.6783 43.3227 33.6217Z",
    fill: "#0EA0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3286 33.6175L55.9162 32.7716C56.5233 32.7149 56.9887 32.0794 56.9564 31.4602L56.9483 31.2133C56.9159 30.5981 56.3897 30.1205 55.7826 30.165L43.1909 30.9016C42.5636 30.9461 42.0819 31.6221 42.1022 32.298V32.4437C42.1386 33.0751 42.7012 33.6782 43.3286 33.6175Z",
    fill: "#0FA1D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3326 33.6134L55.9161 32.7675C56.5233 32.7108 56.9887 32.0754 56.9563 31.4602L56.9482 31.2133C56.9159 30.5981 56.3897 30.1205 55.7826 30.165L43.195 30.9016C42.5676 30.9461 42.086 31.618 42.1103 32.2939V32.4437C42.1467 33.0751 42.7052 33.6741 43.3326 33.6134Z",
    fill: "#10A2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3362 33.6134L55.9157 32.7675C56.5229 32.7108 56.9883 32.0794 56.9559 31.4602L56.9478 31.2133C56.9155 30.5981 56.3933 30.1205 55.7822 30.165L43.1986 30.9016C42.5713 30.9461 42.0937 31.618 42.1139 32.2899V32.4437C42.1503 33.0751 42.7129 33.6701 43.3362 33.6134Z",
    fill: "#11A3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3401 33.6089L55.9156 32.763C56.5227 32.7063 56.9882 32.0749 56.9558 31.4597L56.9477 31.2128C56.9153 30.5976 56.3932 30.124 55.7861 30.1645L43.2025 30.9012C42.5752 30.9457 42.0976 31.6135 42.1178 32.2854V32.4432C42.1542 33.0746 42.7168 33.6656 43.3401 33.6089Z",
    fill: "#12A4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3442 33.605L55.9156 32.7591C56.5227 32.7024 56.9882 32.071 56.9517 31.4558L56.9437 31.2089C56.9113 30.5937 56.3892 30.1201 55.782 30.1606L43.2025 30.8973C42.5752 30.9418 42.0976 31.6056 42.1178 32.2774V32.4393C42.1623 33.0707 42.7209 33.6617 43.3442 33.605Z",
    fill: "#13A5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3521 33.601L55.9195 32.755C56.5266 32.6984 56.988 32.071 56.9556 31.4558L56.9475 31.2089C56.9152 30.5937 56.393 30.1201 55.7859 30.1606L43.2105 30.8973C42.5831 30.9418 42.1055 31.6056 42.1298 32.2734V32.4393C42.1662 33.0707 42.7248 33.6576 43.3521 33.601Z",
    fill: "#14A5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.356 33.5969L55.9193 32.751C56.5224 32.6943 56.9879 32.067 56.9555 31.4518L56.9474 31.2089C56.915 30.5937 56.3929 30.1201 55.7858 30.1606L43.2144 30.8973C42.5911 30.9418 42.1094 31.6015 42.1337 32.2693V32.4393C42.1742 33.0707 42.7287 33.6576 43.356 33.5969Z",
    fill: "#15A6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3598 33.5929L55.919 32.7469C56.5221 32.6903 56.9876 32.067 56.9552 31.4518L56.9471 31.2089C56.9147 30.5937 56.3926 30.1201 55.7895 30.1606L43.2222 30.8973C42.5989 30.9418 42.1172 31.5975 42.1415 32.2653V32.4393C42.1779 33.0707 42.7365 33.6536 43.3598 33.5929Z",
    fill: "#16A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3636 33.5888L55.9188 32.7469C56.5218 32.6903 56.9873 32.067 56.9549 31.4518L56.9468 31.2089C56.9145 30.5937 56.3923 30.1201 55.7893 30.1606L43.226 30.8973C42.6026 30.9418 42.125 31.5975 42.1493 32.2653V32.4393C42.1817 33.0707 42.7403 33.6495 43.3636 33.5888Z",
    fill: "#17A8D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3676 33.5887L55.9188 32.7468C56.5218 32.6901 56.9873 32.0709 56.9509 31.4557L56.9428 31.2128C56.9104 30.5976 56.3883 30.124 55.7852 30.1645L43.226 30.9012C42.6026 30.9457 42.125 31.5973 42.1493 32.2652V32.4432C42.1898 33.0666 42.7443 33.6453 43.3676 33.5887Z",
    fill: "#18A9D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3714 33.5846L55.9225 32.7427C56.5256 32.6861 56.987 32.0668 56.9547 31.4556L56.9466 31.2128C56.9142 30.6016 56.3921 30.124 55.789 30.1645L43.2338 30.9011C42.6105 30.9457 42.1329 31.5973 42.1571 32.2611V32.4432C42.1936 33.0665 42.7481 33.6413 43.3714 33.5846Z",
    fill: "#19A9D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3753 33.5807L55.9224 32.7388C56.5255 32.6822 56.9869 32.067 56.9545 31.4517L56.9464 31.2089C56.914 30.5977 56.3919 30.1201 55.7888 30.1606L43.2377 30.8972C42.6144 30.9418 42.1368 31.5893 42.161 32.2531V32.4393C42.1975 33.0667 42.752 33.6374 43.3753 33.5807Z",
    fill: "#1AAAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3812 33.5767L55.9242 32.7348C56.5273 32.6781 56.9887 32.0629 56.9563 31.4517L56.9483 31.2089C56.9159 30.5977 56.3978 30.1201 55.7947 30.1606L43.2476 30.8972C42.6243 30.9418 42.1467 31.5853 42.175 32.2491V32.4393C42.2074 33.0667 42.7619 33.6333 43.3812 33.5767Z",
    fill: "#1BABD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3848 33.5729L55.9238 32.7311C56.5269 32.6744 56.9883 32.0632 56.9559 31.448L56.9478 31.2092C56.9154 30.5981 56.3974 30.1205 55.7943 30.165L43.2512 30.9016C42.6279 30.9461 42.1543 31.5897 42.1786 32.2494V32.4437C42.211 33.067 42.7655 33.6337 43.3848 33.5729Z",
    fill: "#1CACD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3888 33.5689L55.9238 32.727C56.5269 32.6704 56.9883 32.0592 56.9519 31.448L56.9438 31.2092C56.9114 30.5981 56.3933 30.1205 55.7902 30.165L43.2512 30.9016C42.6279 30.9461 42.1543 31.5856 42.1786 32.2454V32.4437C42.2191 33.063 42.7696 33.6296 43.3888 33.5689Z",
    fill: "#1DADD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3929 33.5689L55.9238 32.727C56.5228 32.6704 56.9842 32.0632 56.9518 31.448L56.9438 31.2092C56.9114 30.5981 56.3933 30.1205 55.7902 30.165L43.2512 30.9016C42.6319 30.9461 42.1543 31.5816 42.1786 32.2413V32.4437C42.2231 33.063 42.7736 33.6256 43.3929 33.5689Z",
    fill: "#1EAED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3968 33.5649L55.9237 32.723C56.5227 32.6663 56.9841 32.0592 56.9517 31.448L56.9436 31.2092C56.9113 30.5981 56.3932 30.1205 55.7942 30.165L43.2592 30.8976C42.6399 30.9421 42.1623 31.5775 42.1907 32.2332V32.4356C42.2271 33.063 42.7775 33.6215 43.3968 33.5649Z",
    fill: "#1FAED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4046 33.5609L55.9274 32.7191C56.5265 32.6624 56.9879 32.0593 56.9555 31.4441L56.9474 31.2053C56.915 30.5942 56.3969 30.1166 55.7979 30.1611L43.267 30.8937C42.6477 30.9382 42.1701 31.5696 42.1985 32.2253V32.4317C42.2349 33.0631 42.7853 33.6176 43.4046 33.5609Z",
    fill: "#20AFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4082 33.5564L55.927 32.7146C56.526 32.6579 56.9874 32.0548 56.9551 31.4437L56.947 31.2049C56.9146 30.5937 56.3965 30.1201 55.7975 30.1606L43.2706 30.8932C42.6513 30.9377 42.1778 31.5651 42.2021 32.2208V32.4312C42.2385 33.0586 42.7889 33.6131 43.4082 33.5564Z",
    fill: "#21B0D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4123 33.5524L55.927 32.7105C56.526 32.6539 56.9874 32.0508 56.951 31.4396L56.9429 31.2049C56.9105 30.5937 56.3925 30.1201 55.7934 30.1606L43.2706 30.8932C42.6513 30.9377 42.1778 31.5651 42.2021 32.2167V32.4312C42.2425 33.0586 42.793 33.609 43.4123 33.5524Z",
    fill: "#22B1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4163 33.5483L55.927 32.7065C56.5261 32.6498 56.9834 32.0508 56.951 31.4396L56.9429 31.2049C56.9106 30.5937 56.3925 30.1201 55.7935 30.1606L43.2747 30.8932C42.6554 30.9377 42.1819 31.561 42.2102 32.2127V32.4312C42.2507 33.0586 42.7971 33.6091 43.4163 33.5483Z",
    fill: "#23B2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4201 33.5482L55.9267 32.7063C56.5258 32.6497 56.9831 32.0506 56.9508 31.4435L56.9427 31.2088C56.9103 30.5976 56.3963 30.124 55.7972 30.1645L43.2825 30.8971C42.6632 30.9416 42.1897 31.5649 42.218 32.2166V32.4392C42.2544 33.0585 42.8008 33.6049 43.4201 33.5482Z",
    fill: "#23B2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4239 33.5443L55.9305 32.7024C56.5295 32.6457 56.9869 32.0508 56.9545 31.4396L56.9464 31.2048C56.9141 30.5977 56.4 30.1201 55.801 30.1606L43.2903 30.8932C42.671 30.9377 42.1975 31.557 42.2258 32.2086V32.4353C42.2622 33.0586 42.8087 33.6009 43.4239 33.5443Z",
    fill: "#24B3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4297 33.5401L55.9323 32.7023C56.5273 32.6456 56.9887 32.0506 56.9563 31.4435L56.9482 31.2088C56.9159 30.6016 56.4018 30.124 55.8028 30.1645L43.2962 30.8971C42.6809 30.9416 42.2033 31.5568 42.2317 32.2085V32.4351C42.2681 33.0544 42.8145 33.5968 43.4297 33.5401Z",
    fill: "#25B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4336 33.5362L55.9322 32.6984C56.5272 32.6417 56.9886 32.0508 56.9521 31.4396L56.944 31.2048C56.9117 30.5977 56.3976 30.1201 55.7986 30.1606L43.296 30.8932C42.6808 30.9377 42.2073 31.5529 42.2356 32.2005V32.4312C42.272 33.0545 42.8184 33.5928 43.4336 33.5362Z",
    fill: "#26B5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4375 33.5321L55.932 32.6943C56.527 32.6376 56.9844 32.0467 56.952 31.4396L56.9439 31.2048C56.9115 30.5977 56.3975 30.1201 55.7985 30.1606L43.2999 30.8932C42.6847 30.9377 42.2112 31.5489 42.2395 32.1965V32.4312C42.28 33.0545 42.8223 33.5888 43.4375 33.5321Z",
    fill: "#27B6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4413 33.5281L55.9318 32.6903C56.5267 32.6336 56.9841 32.0467 56.9517 31.4355L56.9436 31.2048C56.9112 30.5977 56.3972 30.1201 55.8022 30.1606L43.3077 30.8932C42.6925 30.9377 42.219 31.5448 42.2473 32.1924V32.4312C42.2837 33.0545 42.8261 33.5847 43.4413 33.5281Z",
    fill: "#28B6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4452 33.524L55.9316 32.6862C56.5266 32.6295 56.984 32.0427 56.9516 31.4355L56.9435 31.2048C56.9111 30.5977 56.3971 30.1201 55.8021 30.1606L43.3116 30.8932C42.6964 30.9377 42.2229 31.5448 42.2512 32.1884V32.4312C42.2876 33.0545 42.834 33.5847 43.4452 33.524Z",
    fill: "#29B7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4534 33.524L55.9357 32.6862C56.5307 32.6295 56.9881 32.0467 56.9557 31.4355L56.9476 31.2048C56.9152 30.5977 56.4012 30.1201 55.8062 30.1606L43.3158 30.8932C42.7006 30.9377 42.227 31.5408 42.2594 32.1843V32.4312C42.2958 33.0505 42.8382 33.5807 43.4534 33.524Z",
    fill: "#2AB8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4571 33.52L55.9354 32.6822C56.5304 32.6255 56.9877 32.0427 56.9513 31.4355L56.9432 31.2048C56.9108 30.5977 56.3968 30.1201 55.8018 30.1606L43.3154 30.8932C42.7002 30.9377 42.2307 31.5367 42.259 32.1803V32.4312C42.2995 33.0505 42.8419 33.5767 43.4571 33.52Z",
    fill: "#2BB9DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4608 33.5163L55.9351 32.6785C56.5301 32.6218 56.9834 32.043 56.951 31.4359L56.9429 31.2052C56.9106 30.5981 56.3965 30.1205 55.8056 30.165L43.3232 30.8976C42.708 30.9421 42.2385 31.5411 42.2668 32.1806V32.4356C42.3073 33.0508 42.8456 33.573 43.4608 33.5163Z",
    fill: "#2CBADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4647 33.5124L55.935 32.6746C56.53 32.6179 56.9833 32.0391 56.9509 31.432L56.9428 31.2013C56.9104 30.5942 56.4004 30.1166 55.8054 30.1611L43.3271 30.8937C42.7119 30.9382 42.2424 31.5332 42.2707 32.1727V32.4277C42.3112 33.051 42.8495 33.569 43.4647 33.5124Z",
    fill: "#2DBBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4689 33.5082L55.935 32.6704C56.526 32.6137 56.9833 32.039 56.9509 31.4318L56.9429 31.2052C56.9105 30.5981 56.4005 30.1205 55.8055 30.165L43.3312 30.8935C42.7201 30.934 42.2465 31.533 42.2789 32.1685V32.4275C42.3153 33.0508 42.8577 33.5649 43.4689 33.5082Z",
    fill: "#2EBBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4728 33.5038L55.9349 32.666C56.5258 32.6093 56.9832 32.0346 56.9508 31.4275L56.9427 31.2008C56.9103 30.5937 56.4003 30.1201 55.8054 30.1606L43.3352 30.8892C42.724 30.9296 42.2504 31.5246 42.2828 32.1601V32.4231C42.3233 33.0465 42.8616 33.5605 43.4728 33.5038Z",
    fill: "#2FBCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4783 33.5037L55.9404 32.6658C56.5313 32.6092 56.9887 32.0344 56.9523 31.4314L56.9442 31.2047C56.9118 30.6016 56.4018 30.124 55.8068 30.1645L43.3407 30.893C42.7295 30.9335 42.26 31.5245 42.2883 32.164V32.4311C42.3288 33.0463 42.8671 33.5603 43.4783 33.5037Z",
    fill: "#30BDDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.482 33.4998L55.9401 32.6619C56.531 32.6053 56.9844 32.0346 56.952 31.4275L56.9439 31.2008C56.9115 30.5977 56.4015 30.1201 55.8106 30.1606L43.3485 30.8891C42.7373 30.9296 42.2678 31.5205 42.2961 32.156V32.4272C42.3326 33.0464 42.8709 33.5564 43.482 33.4998Z",
    fill: "#31BEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4862 33.4957L55.9402 32.6579C56.5311 32.6012 56.9844 32.0305 56.9521 31.4275L56.944 31.2008C56.9116 30.5977 56.4016 30.1201 55.8107 30.1606L43.3526 30.8891C42.7414 30.9296 42.2719 31.5165 42.3043 32.1519V32.4272C42.3407 33.0464 42.8791 33.5524 43.4862 33.4957Z",
    fill: "#32BFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4901 33.4917L55.9401 32.6579C56.531 32.6012 56.9843 32.0346 56.9519 31.4275L56.9438 31.2008C56.9115 30.5977 56.4015 30.1201 55.8105 30.1606L43.3565 30.8891C42.7454 30.9296 42.2758 31.5124 42.3082 32.1479V32.4272C42.3446 33.0464 42.883 33.5483 43.4901 33.4917Z",
    fill: "#33BFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.494 33.4876L55.9399 32.6538C56.5308 32.5972 56.9842 32.0305 56.9518 31.4275L56.9437 31.2008C56.9113 30.5977 56.4013 30.1201 55.8104 30.1606L43.3604 30.8891C42.7492 30.9296 42.2797 31.5124 42.3121 32.1439V32.4272C42.3526 33.0424 42.8869 33.5443 43.494 33.4876Z",
    fill: "#34C0DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4975 33.4836L55.9394 32.6498C56.5304 32.5931 56.9837 32.0305 56.9472 31.4234L56.9391 31.2008C56.9068 30.5977 56.3968 30.1201 55.8099 30.1606L43.364 30.8891C42.7528 30.9296 42.2873 31.5084 42.3157 32.1398V32.4231C42.3562 33.0424 42.8904 33.5402 43.4975 33.4836Z",
    fill: "#35C1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5057 33.4795L55.9435 32.6457C56.5345 32.5891 56.9837 32.0265 56.9514 31.4234L56.9433 31.2008C56.9109 30.5977 56.4009 30.1201 55.814 30.1606L43.3681 30.8891C42.761 30.9296 42.2915 31.5084 42.3238 32.1358V32.4231C42.3603 33.0424 42.8945 33.5362 43.5057 33.4795Z",
    fill: "#36C2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5096 33.4794L55.9434 32.6456C56.5303 32.5889 56.9836 32.0304 56.9512 31.4273L56.9431 31.2047C56.9108 30.6016 56.4048 30.124 55.8139 30.1645L43.372 30.893C42.7649 30.9335 42.2954 31.5083 42.3278 32.1356V32.427C42.3682 33.0422 42.9025 33.536 43.5096 33.4794Z",
    fill: "#37C3DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5135 33.4755L55.9433 32.6417C56.5301 32.585 56.9835 32.0265 56.9511 31.4234L56.943 31.2008C56.9106 30.5977 56.4047 30.1201 55.8137 30.1606L43.3759 30.8891C42.7688 30.9296 42.2993 31.5003 42.3317 32.1277V32.4231C42.3721 33.0424 42.9064 33.5321 43.5135 33.4755Z",
    fill: "#38C4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5174 33.4714L55.9431 32.6376C56.53 32.581 56.9833 32.0265 56.9509 31.4234L56.9428 31.2008C56.9105 30.5977 56.4045 30.1201 55.8136 30.1606L43.3798 30.8891C42.7727 30.9296 42.3032 31.5003 42.3356 32.1236V32.4231C42.3801 33.0383 42.9103 33.5281 43.5174 33.4714Z",
    fill: "#39C4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5216 33.4675L55.9432 32.6337C56.5301 32.5771 56.9834 32.0226 56.947 31.4195L56.9389 31.1969C56.9065 30.5938 56.4006 30.1162 55.8137 30.1567L43.384 30.8852C42.7769 30.9257 42.3074 31.4923 42.3438 32.1157V32.4192C42.3843 33.0385 42.9145 33.5242 43.5216 33.4675Z",
    fill: "#3AC5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5251 33.4633L55.9427 32.6295C56.5296 32.5729 56.9789 32.0224 56.9465 31.4194L56.9384 31.2008C56.906 30.5977 56.4001 30.1201 55.8132 30.1606L43.3875 30.8891C42.7804 30.9296 42.3149 31.4922 42.3473 32.1155V32.4231C42.3878 33.0383 42.918 33.52 43.5251 33.4633Z",
    fill: "#3BC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5307 33.4594L55.9483 32.6256C56.5352 32.569 56.9844 32.0185 56.9521 31.4155L56.948 31.1969C56.9156 30.5938 56.4097 30.1162 55.8228 30.1567L43.4012 30.8852C42.794 30.9257 42.3286 31.4883 42.361 32.1076V32.4192C42.3974 33.0385 42.9276 33.5161 43.5307 33.4594Z",
    fill: "#3CC7E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5346 33.4596L55.9481 32.6258C56.535 32.5732 56.9843 32.0228 56.9519 31.4197L56.9479 31.2011C56.9155 30.6021 56.4096 30.1204 55.8227 30.165L43.4051 30.8935C42.7979 30.934 42.3325 31.4925 42.3649 32.1158V32.4275C42.4013 33.0387 42.9315 33.5163 43.5346 33.4596Z",
    fill: "#3DC8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5387 33.4552L55.9483 32.6215C56.5351 32.5688 56.9844 32.0184 56.952 31.4153L56.948 31.1967C56.9156 30.5977 56.4097 30.1201 55.8228 30.1606L43.4092 30.8891C42.8062 30.9296 42.3367 31.4841 42.3731 32.1074V32.4231C42.4055 33.0343 42.9357 33.5119 43.5387 33.4552Z",
    fill: "#3EC8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5426 33.4512L55.9481 32.6174C56.5309 32.5648 56.9843 32.0143 56.9478 31.4153L56.9438 31.1967C56.9114 30.5977 56.4055 30.1201 55.8226 30.1606L43.4131 30.8851C42.8101 30.9256 42.3406 31.4801 42.377 32.0993V32.4191C42.4134 33.0343 42.9396 33.5078 43.5426 33.4512Z",
    fill: "#3FC9E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5462 33.4471L55.9476 32.6134C56.5304 32.5607 56.9797 32.0143 56.9473 31.4153L56.9433 31.1967C56.9109 30.5977 56.4049 30.1201 55.8221 30.1606L43.4167 30.8851C42.8136 30.9256 42.3481 31.476 42.3805 32.0953V32.4191C42.4169 33.0343 42.9431 33.5038 43.5462 33.4471Z",
    fill: "#40CAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5501 33.4432L55.9474 32.6095C56.5303 32.5568 56.9795 32.0104 56.9472 31.4114L56.9431 31.1928C56.9107 30.5938 56.4088 30.1162 55.822 30.1567L43.4205 30.8812C42.8175 30.9217 42.352 31.4721 42.3844 32.0873V32.4152C42.4249 33.0344 42.9511 33.4999 43.5501 33.4432Z",
    fill: "#41CBE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5583 33.4389L55.9516 32.6092C56.5344 32.5566 56.9837 32.0142 56.9513 31.4152L56.9473 31.2007C56.9149 30.6016 56.413 30.124 55.8261 30.1645L43.4247 30.889C42.8217 30.9295 42.3562 31.4759 42.3926 32.0911V32.423C42.4291 33.0301 42.9552 33.4956 43.5583 33.4389Z",
    fill: "#42CCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5621 33.435L55.9513 32.6053C56.5342 32.5526 56.9834 32.0103 56.9511 31.4113L56.947 31.1967C56.9146 30.5977 56.4127 30.1201 55.8299 30.1606L43.4325 30.8851C42.8295 30.9256 42.364 31.4679 42.4004 32.0831V32.4191C42.4328 33.0302 42.959 33.4917 43.5621 33.435Z",
    fill: "#43CDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5661 33.4349L55.9513 32.6051C56.5342 32.5525 56.9834 32.0142 56.947 31.4152L56.943 31.2007C56.9106 30.6016 56.4087 30.124 55.8259 30.1645L43.4325 30.889C42.8295 30.9295 42.364 31.4718 42.4004 32.083V32.423C42.4409 33.0301 42.963 33.4915 43.5661 33.4349Z",
    fill: "#44CDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5696 33.4309L55.9508 32.6012C56.5336 32.5486 56.9788 32.0103 56.9465 31.4113L56.9424 31.1967C56.91 30.5977 56.4081 30.1201 55.8253 30.1606L43.4361 30.8851C42.833 30.9256 42.3716 31.4639 42.4039 32.075V32.415C42.4444 33.0302 42.9665 33.4876 43.5696 33.4309Z",
    fill: "#45CEE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5738 33.4269L55.9509 32.5972C56.5338 32.5446 56.979 32.0103 56.9466 31.4113L56.9426 31.1967C56.9102 30.5977 56.4083 30.1201 55.8254 30.1606L43.4402 30.8851C42.8372 30.9256 42.3757 31.4598 42.4122 32.071V32.415C42.4486 33.0302 42.9748 33.4836 43.5738 33.4269Z",
    fill: "#46CFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5738 33.4268L55.9509 32.5971C56.5338 32.5445 56.979 31.9414 56.9466 31.3424L56.9426 31.2372C56.9102 30.6381 56.4083 30.116 55.8254 30.1565L43.4402 30.881C42.8372 30.9215 42.3757 31.4557 42.4122 32.0669V32.4109C42.4486 33.0302 42.9748 33.4835 43.5738 33.4268Z",
    fill: "url(#paint7_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.3116 32.249C42.3399 32.9533 42.9268 33.4754 43.6311 33.4228C44.3353 33.3702 44.8858 32.755 44.8615 32.0507C44.8372 31.3424 44.2422 30.8162 43.538 30.8689C42.8337 30.9255 42.2833 31.5448 42.3116 32.249Z",
    fill: "url(#paint8_radial_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4455 34.3533L39.5612 33.908C40.1805 33.8514 40.6257 33.1835 40.5609 32.5643L40.5366 32.3052C40.4759 31.6819 39.9174 31.2084 39.2981 31.2529L33.2229 31.5888C32.5834 31.6334 32.1179 32.3457 32.1543 33.0419L32.1584 33.135C32.215 33.7745 32.81 34.414 33.4455 34.3533Z",
    fill: "#0095CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4494 34.3493L39.561 33.9041C40.1803 33.8474 40.6255 33.1837 40.5608 32.5603L40.5365 32.3013C40.4758 31.682 39.9172 31.2044 39.298 31.249L33.2268 31.5849C32.5913 31.6294 32.1218 32.3418 32.1582 33.0339L32.1623 33.131C32.223 33.7705 32.8139 34.41 33.4494 34.3493Z",
    fill: "#0196CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4534 34.3447L39.5611 33.8994C40.1763 33.8428 40.6215 33.179 40.5608 32.5597L40.5365 32.3048C40.4758 31.6855 39.9172 31.2119 39.302 31.2524L33.2349 31.5883C32.5994 31.6329 32.1299 32.3412 32.1704 33.0333L32.1745 33.1345C32.2271 33.7699 32.818 34.4054 33.4534 34.3447Z",
    fill: "#0297CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4573 34.3408L39.5609 33.8955C40.1761 33.8389 40.6214 33.1791 40.5606 32.5558L40.5364 32.3008C40.4756 31.6816 39.9171 31.208 39.3019 31.2485L33.2388 31.5844C32.6033 31.629 32.1338 32.3373 32.1743 33.0253L32.1783 33.1306C32.235 33.7701 32.8259 34.4015 33.4573 34.3408Z",
    fill: "#0397CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.461 34.3406L39.5605 33.8954C40.1757 33.8387 40.6209 33.179 40.5562 32.5597L40.5319 32.3048C40.4712 31.6855 39.9167 31.2119 39.2974 31.2524L33.2383 31.5883C32.6029 31.6329 32.1374 32.3371 32.1739 33.0252L32.1779 33.1345C32.2386 33.7699 32.8296 34.3973 33.461 34.3406Z",
    fill: "#0498CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4707 34.3367L39.5662 33.8915C40.1814 33.8348 40.6266 33.1791 40.5619 32.5558L40.5376 32.3008C40.4769 31.6816 39.9224 31.208 39.3031 31.2485L33.2481 31.5844C32.6127 31.629 32.1472 32.3292 32.1836 33.0172L32.1877 33.1306C32.2443 33.766 32.8353 34.3934 33.4707 34.3367Z",
    fill: "#0599CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4745 34.3327L39.5659 33.8875C40.1811 33.8308 40.6264 33.1751 40.5616 32.5558L40.5373 32.3008C40.4766 31.6816 39.9221 31.208 39.3069 31.2485L33.2559 31.5844C32.6205 31.629 32.155 32.3292 32.1915 33.0132L32.1955 33.1306C32.2522 33.766 32.839 34.3893 33.4745 34.3327Z",
    fill: "#069ACD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4769 34.3285L39.5643 33.8873C40.1795 33.8306 40.6207 33.179 40.56 32.5597L40.5357 32.3048C40.475 31.6855 39.9205 31.2119 39.3052 31.2524L33.2543 31.5883C32.6188 31.6329 32.1534 32.329 32.1939 33.0131L32.1979 33.1304C32.2546 33.7659 32.8414 34.3892 33.4769 34.3285Z",
    fill: "#079BCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4826 34.3244L39.5659 33.8833C40.1812 33.8266 40.6223 33.175 40.5616 32.5557L40.5414 32.3048C40.4807 31.6855 39.9262 31.2119 39.311 31.2524L33.2641 31.5883C32.6286 31.6329 32.1631 32.325 32.2036 33.009L32.2077 33.1304C32.2603 33.7659 32.8472 34.3851 33.4826 34.3244Z",
    fill: "#089CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4861 34.3207L39.5654 33.8796C40.1806 33.8229 40.6217 33.1753 40.561 32.556L40.5408 32.3051C40.4801 31.6858 39.9256 31.2123 39.3104 31.2568L33.2675 31.5927C32.6361 31.6373 32.1707 32.3294 32.2071 33.0094L32.2111 33.1348C32.2678 33.7662 32.8547 34.3814 33.4861 34.3207Z",
    fill: "#099CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4901 34.3207L39.5654 33.8796C40.1765 33.8229 40.6217 33.1753 40.557 32.556L40.5367 32.3051C40.476 31.6858 39.9215 31.2123 39.3063 31.2568L33.2675 31.5927C32.6361 31.6373 32.1707 32.3253 32.2071 33.0094L32.2111 33.1389C32.2718 33.7622 32.8587 34.3774 33.4901 34.3207Z",
    fill: "#0A9DCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4941 34.3167L39.5693 33.8755C40.1805 33.8188 40.6257 33.1753 40.5609 32.556L40.5407 32.3051C40.48 31.6858 39.9255 31.2123 39.3143 31.2568L33.2795 31.5927C32.6481 31.6373 32.1827 32.3253 32.2232 33.0053L32.2272 33.1389C32.2798 33.7622 32.8626 34.3733 33.4941 34.3167Z",
    fill: "#0B9ECF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.498 34.3128L39.5692 33.8716C40.1803 33.8149 40.6255 33.1714 40.5608 32.5521L40.5405 32.3012C40.4798 31.6819 39.9253 31.2084 39.3142 31.2529L33.2835 31.5888C32.652 31.6334 32.1866 32.3174 32.2271 32.9974L32.2311 33.135C32.2837 33.7623 32.8666 34.3694 33.498 34.3128Z",
    fill: "#0C9FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5019 34.3087L39.569 33.8675C40.1802 33.8109 40.6214 33.1714 40.5606 32.5521L40.5404 32.3012C40.4797 31.686 39.9292 31.2084 39.314 31.2529L33.2874 31.5888C32.656 31.6333 32.1905 32.3133 32.231 32.9933L32.235 33.1349C32.2876 33.7623 32.8705 34.3694 33.5019 34.3087Z",
    fill: "#0DA0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5058 34.3048L39.5689 33.8636C40.18 33.807 40.6212 33.1675 40.5605 32.5482L40.5403 32.2973C40.4795 31.6821 39.9291 31.2044 39.3139 31.249L33.2913 31.5809C32.6598 31.6254 32.1944 32.3054 32.2349 32.9813L32.2389 33.127C32.2956 33.7624 32.8784 34.3655 33.5058 34.3048Z",
    fill: "#0EA0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5094 34.3006L39.5685 33.8594C40.1796 33.8028 40.6208 33.1633 40.5601 32.5481L40.5399 32.3012C40.4791 31.686 39.9287 31.2084 39.3175 31.2529L33.299 31.5848C32.6675 31.6293 32.2061 32.3052 32.2466 32.9811L32.2507 33.1268C32.2992 33.7583 32.8821 34.3613 33.5094 34.3006Z",
    fill: "#0FA1D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5135 34.3006L39.5685 33.8594C40.1796 33.8028 40.6208 33.1673 40.556 32.5481L40.5358 32.3012C40.4751 31.686 39.9246 31.2084 39.3135 31.2529L33.299 31.5848C32.6675 31.6293 32.2061 32.3012 32.2466 32.9771L32.2507 33.1268C32.3033 33.7583 32.8861 34.3573 33.5135 34.3006Z",
    fill: "#10A2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5193 34.2961L39.5703 33.8549C40.1814 33.7983 40.6226 33.1628 40.5579 32.5476L40.5376 32.3007C40.4769 31.6855 39.9265 31.2119 39.3153 31.2524L33.3048 31.5843C32.6734 31.6288 32.212 32.3007 32.2525 32.9726L32.2565 33.1264C32.3132 33.7578 32.892 34.3528 33.5193 34.2961Z",
    fill: "#11A3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5232 34.2921L39.5701 33.8509C40.1813 33.7942 40.6184 33.1628 40.5577 32.5476L40.5375 32.3007C40.4767 31.6855 39.9263 31.2119 39.3151 31.2524L33.3087 31.5843C32.6813 31.6288 32.2159 32.2967 32.2564 32.9685L32.2604 33.1264C32.3171 33.7578 32.8958 34.3487 33.5232 34.2921Z",
    fill: "#12A4D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5271 34.2882L39.57 33.847C40.1771 33.7903 40.6183 33.1589 40.5576 32.5437L40.5373 32.2968C40.4766 31.6816 39.9262 31.208 39.315 31.2485L33.3126 31.5804C32.6852 31.6249 32.2198 32.2887 32.2603 32.9606L32.2643 33.1225C32.325 33.7579 32.9038 34.3448 33.5271 34.2882Z",
    fill: "#13A5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5353 34.2841L39.5741 33.8429C40.1812 33.7863 40.6224 33.1589 40.5617 32.5437L40.5414 32.2968C40.4807 31.6816 39.9303 31.208 39.3231 31.2485L33.3208 31.5804C32.6934 31.6249 32.228 32.2887 32.2725 32.9565L32.2806 33.1225C32.3291 33.7539 32.9079 34.3448 33.5353 34.2841Z",
    fill: "#14A5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5387 34.2801L39.5735 33.8389C40.1806 33.7822 40.6218 33.1549 40.5611 32.5396L40.5408 32.2968C40.4801 31.6816 39.9296 31.208 39.3225 31.2485L33.3242 31.5804C32.6968 31.6249 32.2354 32.2847 32.2759 32.9525L32.284 33.1225C32.3326 33.7539 32.9114 34.3408 33.5387 34.2801Z",
    fill: "#15A6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5428 34.2759L39.5735 33.8387C40.1806 33.7821 40.6218 33.1588 40.557 32.5435L40.5368 32.3007C40.4761 31.6855 39.9256 31.2119 39.3185 31.2524L33.3242 31.5843C32.6968 31.6288 32.2354 32.2886 32.2759 32.9523L32.284 33.1264C32.3407 33.7537 32.9154 34.3366 33.5428 34.2759Z",
    fill: "#16A7D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5467 34.2759L39.5733 33.8387C40.1805 33.7821 40.6216 33.1588 40.5569 32.5435L40.5366 32.3007C40.4759 31.6855 39.9295 31.2119 39.3184 31.2524L33.3281 31.5843C32.7008 31.6288 32.2393 32.2845 32.2798 32.9523L32.2879 33.1264C32.3446 33.7537 32.9193 34.3325 33.5467 34.2759Z",
    fill: "#17A8D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5508 34.2718L39.5734 33.8347C40.1805 33.778 40.6177 33.1588 40.5569 32.5435L40.5367 32.3007C40.476 31.6855 39.9296 31.2119 39.3225 31.2524L33.3363 31.5843C32.7089 31.6288 32.2475 32.2805 32.292 32.9483L32.3001 33.1264C32.3527 33.7537 32.9234 34.3285 33.5508 34.2718Z",
    fill: "#18A9D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5547 34.2679L39.5733 33.8308C40.1804 33.7741 40.6175 33.1548 40.5568 32.5396L40.5366 32.2968C40.4758 31.6856 39.9294 31.208 39.3223 31.2485L33.3402 31.5804C32.7128 31.6249 32.2514 32.2765 32.2959 32.9403L32.304 33.1225C32.3566 33.7498 32.9314 34.3246 33.5547 34.2679Z",
    fill: "#19A9D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5584 34.2642L39.577 33.8271C40.1841 33.7704 40.6213 33.1552 40.5605 32.54L40.5403 32.2971C40.4796 31.686 39.9332 31.2084 39.3261 31.2529L33.348 31.5848C32.7247 31.6293 32.2592 32.2769 32.3037 32.9407L32.3118 33.1268C32.3604 33.7502 32.9351 34.3208 33.5584 34.2642Z",
    fill: "#1AAAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.562 34.2601L39.5765 33.823C40.1796 33.7664 40.6208 33.1511 40.556 32.54L40.5358 32.2971C40.4751 31.686 39.9287 31.2084 39.3215 31.2529L33.3475 31.5848C32.7242 31.6293 32.2628 32.2728 32.3033 32.9366L32.3113 33.1268C32.368 33.7502 32.9387 34.3208 33.562 34.2601Z",
    fill: "#1BABD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5679 34.2561L39.5784 33.819C40.1814 33.7623 40.6226 33.1511 40.5578 32.5359L40.5376 32.2971C40.4769 31.686 39.9305 31.2084 39.3234 31.2529L33.3534 31.5848C32.73 31.6293 32.2686 32.2728 32.3091 32.9326L32.3172 33.1268C32.3739 33.7502 32.9446 34.3168 33.5679 34.2561Z",
    fill: "#1CACD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.57 34.256L39.5765 33.8188C40.1795 33.7622 40.6167 33.151 40.556 32.5398L40.5357 32.301C40.475 31.6899 39.9286 31.2123 39.3255 31.2568L33.3596 31.5887C32.7363 31.6332 32.2749 32.2727 32.3194 32.9324L32.3275 33.1308C32.376 33.75 32.9467 34.3126 33.57 34.256Z",
    fill: "#1DADD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5759 34.252L39.5783 33.8149C40.1813 33.7583 40.6185 33.1471 40.5578 32.5359L40.5375 32.2971C40.4768 31.686 39.9304 31.2084 39.3273 31.2529L33.3654 31.5807C32.7421 31.6252 32.2807 32.2607 32.3252 32.9204L32.3333 33.1228C32.3859 33.7461 32.9566 34.3087 33.5759 34.252Z",
    fill: "#1EAED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5798 34.248L39.5781 33.8109C40.1812 33.7542 40.6183 33.1471 40.5576 32.5359L40.5374 32.2971C40.4767 31.686 39.9303 31.2084 39.3272 31.2529L33.3693 31.5807C32.746 31.6252 32.2846 32.2607 32.3291 32.9164L32.3372 33.1188C32.3899 33.7461 32.9605 34.3047 33.5798 34.248Z",
    fill: "#1FAED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5839 34.2436L39.5781 33.8065C40.1812 33.7498 40.6183 33.1427 40.5576 32.5316L40.5374 32.2928C40.4767 31.6816 39.9343 31.208 39.3272 31.2485L33.3693 31.5764C32.746 31.6209 32.2846 32.2523 32.3291 32.908L32.3372 33.1144C32.398 33.7458 32.9646 34.3003 33.5839 34.2436Z",
    fill: "#20AFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5876 34.2396L39.5779 33.8025C40.1809 33.7458 40.6181 33.1427 40.5533 32.5316L40.5331 32.2928C40.4724 31.6816 39.93 31.208 39.3269 31.2485L33.3731 31.5764C32.7498 31.6209 32.2925 32.2523 32.337 32.9039L32.3451 33.1144C32.4017 33.7458 32.9684 34.2962 33.5876 34.2396Z",
    fill: "#21B0D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5915 34.2355L39.5777 33.7984C40.1808 33.7417 40.6179 33.1387 40.5532 32.5275L40.5329 32.2928C40.4722 31.6816 39.9298 31.208 39.3268 31.2485L33.377 31.5764C32.7578 31.6209 32.2963 32.2482 32.3409 32.8999L32.349 33.1144C32.4056 33.7417 32.9723 34.2962 33.5915 34.2355Z",
    fill: "#22B1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5993 34.2315L39.5815 33.7944C40.1846 33.7377 40.6176 33.1387 40.5569 32.5275L40.5367 32.2928C40.476 31.6816 39.9336 31.208 39.3305 31.2485L33.3848 31.5764C32.7656 31.6209 32.3041 32.2442 32.3487 32.8958L32.3568 33.1144C32.4134 33.7417 32.9801 34.2922 33.5993 34.2315Z",
    fill: "#23B2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6032 34.2313L39.5813 33.7983C40.1804 33.7416 40.6175 33.1426 40.5568 32.5314L40.5365 32.2967C40.4758 31.6855 39.9335 31.2119 39.3304 31.2524L33.3887 31.5803C32.7695 31.6248 32.3081 32.2481 32.3526 32.8997L32.3607 33.1223C32.4173 33.7416 32.984 34.288 33.6032 34.2313Z",
    fill: "#23B2D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6075 34.2273L39.5816 33.7942C40.1806 33.7375 40.6177 33.1426 40.557 32.5314L40.5368 32.2966C40.4761 31.6895 39.9337 31.2119 39.3307 31.2524L33.393 31.5802C32.7738 31.6248 32.3124 32.244 32.3609 32.8957L32.369 33.1223C32.4216 33.7416 32.9883 34.2839 33.6075 34.2273Z",
    fill: "#24B3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 34.2232L39.5808 33.7901C40.1798 33.7335 40.617 33.1385 40.5562 32.5314L40.536 32.2966C40.4753 31.6895 39.9329 31.2119 39.3339 31.2524L33.4003 31.5802C32.7811 31.6248 32.3237 32.24 32.3682 32.8916L32.3763 33.1183C32.4289 33.7416 32.9915 34.2799 33.6108 34.2232Z",
    fill: "#25B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6148 34.2193L39.5808 33.7862C40.1798 33.7296 40.617 33.1387 40.5522 32.5275L40.532 32.2927C40.4712 31.6856 39.9289 31.208 39.3299 31.2485L33.4003 31.5763C32.7811 31.6209 32.3237 32.2361 32.3682 32.8837L32.3763 33.1144C32.433 33.7377 32.9956 34.276 33.6148 34.2193Z",
    fill: "#26B5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6188 34.2153L39.5807 33.7822C40.1797 33.7255 40.6128 33.1346 40.5521 32.5275L40.5318 32.2927C40.4711 31.6856 39.9287 31.208 39.3297 31.2485L33.4042 31.5763C32.785 31.6209 32.3276 32.232 32.3721 32.8796L32.3802 33.1144C32.4409 33.7377 32.9995 34.2719 33.6188 34.2153Z",
    fill: "#27B6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6245 34.2112L39.5864 33.7782C40.1854 33.7215 40.6185 33.1346 40.5578 32.5234L40.5375 32.2927C40.4768 31.6856 39.9385 31.208 39.3354 31.2485L33.414 31.5763C32.7947 31.6209 32.3374 32.228 32.3819 32.8756L32.39 33.1144C32.4467 33.7377 33.0093 34.2719 33.6245 34.2112Z",
    fill: "#28B6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6267 34.2111L39.5845 33.778C40.1836 33.7213 40.6166 33.1345 40.5559 32.5273L40.5357 32.2966C40.475 31.6895 39.9367 31.2119 39.3377 31.2524L33.4203 31.5802C32.801 31.6248 32.3436 32.2319 32.3922 32.8754L32.4003 33.1183C32.4489 33.7375 33.0115 34.2678 33.6267 34.2111Z",
    fill: "#29B7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6324 34.2075L39.5862 33.7744C40.1852 33.7178 40.6183 33.1349 40.5576 32.5238L40.5414 32.2931C40.4807 31.686 39.9424 31.2084 39.3433 31.2529L33.43 31.5807C32.8148 31.6252 32.3534 32.2283 32.4019 32.8719L32.41 33.1188C32.4586 33.738 33.0172 34.2642 33.6324 34.2075Z",
    fill: "#2AB8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6358 34.2035L39.5855 33.7704C40.1805 33.7137 40.6176 33.1309 40.5569 32.5238L40.5407 32.2931C40.48 31.686 39.9417 31.2084 39.3427 31.2529L33.4334 31.5807C32.8182 31.6252 32.3608 32.2283 32.4053 32.8678L32.4134 33.1188C32.462 33.734 33.0205 34.2601 33.6358 34.2035Z",
    fill: "#2BB9DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.64 34.1996L39.5857 33.7665C40.1806 33.7098 40.6137 33.127 40.553 32.5199L40.5368 32.2892C40.4761 31.6821 39.9378 31.2045 39.3388 31.249L33.4295 31.5768C32.8143 31.6213 32.3569 32.2204 32.4014 32.8599L32.4095 33.1149C32.4662 33.7341 33.0247 34.2562 33.64 34.1996Z",
    fill: "#2CBADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6443 34.1955L39.5859 33.7624C40.1809 33.7058 40.614 33.127 40.5533 32.5199L40.5371 32.2892C40.4764 31.6821 39.9381 31.2045 39.339 31.249L33.4338 31.5768C32.8186 31.6213 32.3612 32.2163 32.4098 32.8558L32.4179 33.1108C32.4746 33.7341 33.0331 34.2522 33.6443 34.1955Z",
    fill: "#2DBBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.648 34.1909L39.5856 33.7578C40.1806 33.7011 40.6137 33.1223 40.553 32.5193L40.5368 32.2926C40.4761 31.6855 39.9378 31.2119 39.3428 31.2524L33.4416 31.5762C32.8264 31.6207 32.369 32.2157 32.4176 32.8512L32.4257 33.1102C32.4783 33.7335 33.0369 34.2475 33.648 34.1909Z",
    fill: "#2EBBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6519 34.187L39.5855 33.7539C40.1805 33.6972 40.6136 33.1225 40.5529 32.5154L40.5367 32.2887C40.4759 31.6816 39.9376 31.208 39.3427 31.2485L33.4455 31.5723C32.8303 31.6168 32.3729 32.2078 32.4215 32.8432L32.4296 33.1063C32.4863 33.7336 33.0408 34.2477 33.6519 34.187Z",
    fill: "#2FBCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6598 34.1868L39.5893 33.7537C40.1843 33.6971 40.6173 33.1223 40.5566 32.5192L40.5404 32.2926C40.4797 31.6895 39.9414 31.2119 39.3464 31.2524L33.4533 31.5762C32.8381 31.6207 32.3807 32.2076 32.4293 32.8471L32.4374 33.1142C32.49 33.7294 33.0445 34.2435 33.6598 34.1868Z",
    fill: "#30BDDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6637 34.1828L39.5892 33.7537C40.1841 33.6971 40.6172 33.1264 40.5525 32.5192L40.5363 32.2926C40.4756 31.6895 39.9372 31.2119 39.3423 31.2524L33.4532 31.5762C32.838 31.6207 32.3847 32.2076 32.4333 32.843L32.4413 33.1142C32.494 33.7294 33.0485 34.2394 33.6637 34.1828Z",
    fill: "#31BEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6674 34.1787L39.5889 33.7497C40.1838 33.693 40.6129 33.1223 40.5521 32.5192L40.536 32.2926C40.4752 31.6895 39.941 31.2119 39.346 31.2524L33.461 31.5762C32.8498 31.6207 32.3925 32.2035 32.441 32.839L32.4491 33.1142C32.5017 33.7294 33.0563 34.2354 33.6674 34.1787Z",
    fill: "#32BFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6713 34.1748L39.5887 33.7458C40.1837 33.6891 40.6127 33.1225 40.552 32.5153L40.5358 32.2887C40.4751 31.6856 39.9408 31.208 39.3459 31.2485L33.4649 31.5723C32.8537 31.6128 32.3964 32.1956 32.4449 32.831L32.453 33.1103C32.5057 33.7296 33.0602 34.2315 33.6713 34.1748Z",
    fill: "#33BFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6752 34.1708L39.5886 33.7417C40.1795 33.6851 40.6126 33.1184 40.5519 32.5153L40.5357 32.2887C40.475 31.6856 39.9407 31.208 39.3457 31.2485L33.4688 31.5723C32.8577 31.6128 32.4003 32.1956 32.4488 32.827L32.457 33.1103C32.5136 33.7296 33.0641 34.2274 33.6752 34.1708Z",
    fill: "#34C0DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6811 34.1667L39.5904 33.7377C40.1813 33.681 40.6144 33.1184 40.5537 32.5113L40.5375 32.2887C40.4768 31.6856 39.9425 31.208 39.3475 31.2485L33.4747 31.5723C32.8635 31.6128 32.4061 32.1915 32.4547 32.823L32.4628 33.1063C32.5195 33.7255 33.0699 34.2274 33.6811 34.1667Z",
    fill: "#35C1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6833 34.1666L39.5926 33.7375C40.1836 33.6809 40.6166 33.1183 40.5559 32.5152L40.5397 32.2926C40.479 31.6895 39.9448 31.2119 39.3498 31.2524L33.481 31.5762C32.8698 31.6167 32.4124 32.1955 32.4651 32.8228L32.4732 33.1102C32.5217 33.7254 33.0722 34.2232 33.6833 34.1666Z",
    fill: "#36C2DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6887 34.1627L39.5939 33.7336C40.1848 33.677 40.6139 33.1184 40.5531 32.5113L40.5369 32.2887C40.4762 31.6856 39.942 31.208 39.351 31.2485L33.4863 31.5723C32.8751 31.6128 32.4218 32.1875 32.4704 32.8149L32.4785 33.1063C32.5311 33.7255 33.0775 34.2193 33.6887 34.1627Z",
    fill: "#37C3DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6926 34.1586L39.5937 33.7296C40.1847 33.6729 40.6137 33.1144 40.553 32.5113L40.5368 32.2887C40.4761 31.6856 39.9418 31.208 39.3509 31.2485L33.4902 31.5723C32.879 31.6128 32.4257 32.1835 32.4743 32.8108L32.4824 33.1063C32.535 33.7255 33.0854 34.2153 33.6926 34.1586Z",
    fill: "#38C4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6966 34.1546L39.5937 33.7255C40.1847 33.6689 40.6137 33.1144 40.553 32.5113L40.5368 32.2887C40.4761 31.6856 39.9418 31.208 39.3509 31.2485L33.4902 31.5723C32.879 31.6128 32.4257 32.1835 32.4743 32.8068L32.4824 33.1063C32.539 33.7255 33.0895 34.2112 33.6966 34.1546Z",
    fill: "#39C4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7009 34.1507L39.594 33.7216C40.1849 33.665 40.614 33.1105 40.5533 32.5074L40.5371 32.2848C40.4764 31.6817 39.9421 31.2041 39.3512 31.2446L33.4945 31.5684C32.8874 31.6089 32.43 32.1755 32.4826 32.7988L32.4907 33.1024C32.5474 33.7216 33.0938 34.2073 33.7009 34.1507Z",
    fill: "#3AC5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7047 34.1468L39.5937 33.7178C40.1847 33.6611 40.6137 33.1066 40.553 32.5076L40.5368 32.289C40.4761 31.686 39.9459 31.2084 39.3549 31.2529L33.5023 31.5767C32.8952 31.6172 32.4378 32.1797 32.4905 32.8031L32.4986 33.1107C32.5512 33.7218 33.0976 34.2035 33.7047 34.1468Z",
    fill: "#3BC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.708 34.1468L39.593 33.7178C40.184 33.6611 40.613 33.1107 40.5523 32.5076L40.5361 32.289C40.4754 31.686 39.9452 31.2084 39.3542 31.2529L33.5057 31.5767C32.8985 31.6172 32.4452 32.1797 32.4938 32.8031L32.5019 33.1147C32.5586 33.7218 33.1009 34.2035 33.708 34.1468Z",
    fill: "#3CC7E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7121 34.1423L39.593 33.7132C40.1799 33.6566 40.609 33.1061 40.5482 32.5071L40.5321 32.2885C40.4713 31.6895 39.9411 31.2119 39.3502 31.2524L33.5057 31.5762C32.8985 31.6167 32.4452 32.1752 32.4938 32.7985L32.5019 33.1102C32.5626 33.7213 33.109 34.1989 33.7121 34.1423Z",
    fill: "#3DC8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7164 34.1384L39.5933 33.7093C40.1802 33.6527 40.6093 33.1063 40.5486 32.5032L40.5324 32.2846C40.4717 31.6856 39.9414 31.208 39.3505 31.2485L33.51 31.5682C32.9029 31.6087 32.4496 32.1632 32.5022 32.7865L32.5103 33.1022C32.567 33.7174 33.1134 34.195 33.7164 34.1384Z",
    fill: "#3EC8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7243 34.1343L39.5971 33.7053C40.184 33.6486 40.613 33.1022 40.5523 32.5032L40.5361 32.2846C40.4754 31.6856 39.9452 31.208 39.3543 31.2485L33.5178 31.5682C32.9107 31.6087 32.4574 32.1632 32.51 32.7825L32.5181 33.1022C32.5748 33.7174 33.1171 34.191 33.7243 34.1343Z",
    fill: "#3FC9E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.728 34.1303L39.5968 33.7053C40.1837 33.6486 40.6127 33.1063 40.552 32.5032L40.5358 32.2846C40.4751 31.6856 39.9449 31.208 39.358 31.2485L33.5256 31.5682C32.9185 31.6087 32.4652 32.1592 32.5178 32.7784L32.53 33.1022C32.5785 33.7174 33.1209 34.1869 33.728 34.1303Z",
    fill: "#40CAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7319 34.1262L39.5967 33.7013C40.1836 33.6446 40.6126 33.1022 40.5519 32.5032L40.5357 32.2846C40.475 31.6856 39.9448 31.208 39.3579 31.2485L33.5296 31.5682C32.9224 31.6087 32.4691 32.1592 32.5217 32.7744L32.5339 33.1022C32.5824 33.7174 33.1248 34.1829 33.7319 34.1262Z",
    fill: "#41CBE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7372 34.122L39.5979 33.6971C40.1848 33.6404 40.6098 33.1021 40.5531 32.5031L40.5369 32.2885C40.4762 31.6895 39.946 31.2119 39.3591 31.2524L33.5348 31.5721C32.9277 31.6126 32.4785 32.159 32.527 32.7742L32.5392 33.1061C32.5918 33.7173 33.1341 34.1787 33.7372 34.122Z",
    fill: "#42CCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7417 34.122L39.5984 33.6971C40.1852 33.6404 40.6102 33.1021 40.5495 32.5031L40.5333 32.2885C40.4726 31.6895 39.9424 31.2119 39.3555 31.2524L33.5353 31.5721C32.9322 31.6126 32.4789 32.155 32.5315 32.7702L32.5436 33.1061C32.5963 33.7132 33.1386 34.1787 33.7417 34.122Z",
    fill: "#43CDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7454 34.118L39.5981 33.693C40.185 33.6404 40.6099 33.1021 40.5492 32.5031L40.533 32.2885C40.4723 31.6895 39.9421 31.2119 39.3593 31.2524L33.5431 31.5721C32.94 31.6126 32.4867 32.155 32.5393 32.7661L32.5514 33.1061C32.6041 33.7132 33.1424 34.1747 33.7454 34.118Z",
    fill: "#44CDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7492 34.1141L39.6018 33.6891C40.1847 33.6365 40.6137 33.0982 40.553 32.4992L40.5368 32.2846C40.4761 31.6856 39.9499 31.208 39.363 31.2485L33.5509 31.5682C32.9478 31.6087 32.4945 32.147 32.5471 32.7582L32.5593 33.0982C32.6078 33.7134 33.1461 34.1708 33.7492 34.1141Z",
    fill: "#45CEE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7533 34.11L39.6018 33.6851C40.1847 33.6324 40.6137 33.0982 40.553 32.4992L40.5368 32.2846C40.4761 31.6856 39.9499 31.208 39.363 31.2485L33.5509 31.5682C32.9478 31.6087 32.4945 32.143 32.5471 32.7541L32.5593 33.0982C32.6119 33.7134 33.1502 34.1667 33.7533 34.11Z",
    fill: "#46CFE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7533 34.11L39.6018 33.685C40.1847 33.6324 40.6097 33.0293 40.5489 32.4303L40.5409 32.3251C40.4801 31.726 39.9499 31.2039 39.363 31.2444L33.5509 31.5641C32.9478 31.6046 32.4945 32.1389 32.5471 32.7501L32.5593 33.0941C32.6119 33.7133 33.1502 34.1667 33.7533 34.11Z",
    fill: "url(#paint9_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.4499 32.9311C32.4944 33.6354 33.1055 34.1575 33.8098 34.1049C34.5181 34.0522 35.0564 33.437 35.0119 32.7328C34.9674 32.0245 34.3562 31.4983 33.6479 31.555C32.9396 31.6116 32.4053 32.2268 32.4499 32.9311Z",
    fill: "url(#paint10_radial_35154_85969)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0314 45.3509L68.8419 44.5212C69.534 44.4524 70.0602 43.7319 70.0156 43.0641L69.9994 42.7889C69.959 42.121 69.3599 41.6191 68.6638 41.6718L56.8331 42.3801C56.1167 42.4327 55.5743 43.2098 55.6026 43.9545L55.6067 44.0557C55.6593 44.7397 56.315 45.4197 57.0314 45.3509Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2059 45.2176L68.8707 44.4C69.5426 44.3352 70.0566 43.6836 70.0161 43.0279L70.004 42.7729C69.9635 42.1172 69.3807 41.6113 68.7047 41.6639L57.0238 42.3641C56.3236 42.4167 55.7974 43.0967 55.8338 43.7969L55.8379 44.0317C55.8824 44.7036 56.5097 45.2864 57.2059 45.2176Z",
    fill: "url(#paint11_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3796 45.0875L68.8946 44.2821C69.5503 44.2173 70.0481 43.6385 70.0076 42.995L69.9995 42.7643C69.9591 42.1207 69.3924 41.6148 68.7367 41.6634L57.2015 42.3515C56.5215 42.4041 56.0034 42.9829 56.052 43.6426L56.056 44.015C56.1046 44.6706 56.7036 45.1523 57.3796 45.0875Z",
    fill: "url(#paint12_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3794 45.0891L68.8944 44.2836C69.5501 44.2189 70.048 43.5713 70.0075 42.9277L70.0034 42.8185C69.963 42.1749 69.3923 41.6204 68.7406 41.669L57.2054 42.3571C56.5254 42.4097 56.0073 42.9885 56.0559 43.6482L56.0599 44.0206C56.1045 44.6722 56.7035 45.1538 57.3794 45.0891Z",
    fill: "url(#paint13_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9496 46.1951L52.8546 45.6487C53.5507 45.5799 54.0486 44.8594 53.9676 44.1916L53.9393 43.9164C53.8624 43.2485 53.2269 42.7426 52.5267 42.7993L45.6622 43.2323C44.9418 43.289 44.4237 44.0621 44.4763 44.8068L44.4844 44.908C44.5492 45.5839 45.2292 46.2679 45.9496 46.1951Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1204 46.0651L52.8756 45.5309C53.5556 45.4621 54.0413 44.8145 53.9644 44.1588L53.9401 43.9038C53.8632 43.2481 53.2439 42.7422 52.564 42.7948L45.8492 43.2157C45.149 43.2683 44.639 43.9483 44.6957 44.6485L44.7078 44.8833C44.7767 45.5511 45.4202 46.1339 46.1204 46.0651Z",
    fill: "url(#paint14_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2927 45.9312L52.8941 45.409C53.5538 45.3443 54.0314 44.7655 53.9545 44.122L53.9343 43.8912C53.8574 43.2477 53.2543 42.7418 52.5946 42.7903L46.0296 43.1991C45.3496 43.2517 44.8437 43.8305 44.9125 44.4862L44.9287 44.8586C44.9975 45.5183 45.6127 46 46.2927 45.9312Z",
    fill: "url(#paint15_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2927 45.9309L52.8941 45.4088C53.5538 45.344 54.0233 44.6924 53.9505 44.0488L53.9383 43.9396C53.8614 43.296 53.2584 42.7415 52.5946 42.7901L46.0296 43.1989C45.3496 43.2515 44.8437 43.8303 44.9125 44.486L44.9287 44.8583C44.9975 45.5181 45.6127 45.9997 46.2927 45.9309Z",
    fill: "url(#paint16_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3134 58.601L40.7731 57.9858C41.4247 57.9129 41.8862 57.241 41.8133 56.6218L41.785 56.3668C41.7121 55.7516 41.1171 55.2983 40.4615 55.359L34.0381 55.869C33.3663 55.9297 32.8806 56.6542 32.9291 57.3382L32.9332 57.4313C33.006 58.0586 33.6415 58.6779 34.3134 58.601Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4751 58.4756L40.7932 57.8725C41.4287 57.7997 41.882 57.1926 41.8091 56.5895L41.7848 56.3547C41.712 55.7517 41.1332 55.2943 40.4937 55.355L34.212 55.8488C33.5564 55.9095 33.0788 56.5409 33.1354 57.1885L33.1476 57.4071C33.2123 58.0263 33.8194 58.5485 34.4751 58.4756Z",
    fill: "url(#paint17_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6333 58.35L40.8097 57.7631C41.429 57.6943 41.8701 57.1519 41.7973 56.561L41.7771 56.3505C41.7042 55.7596 41.1416 55.2982 40.5223 55.3589L34.3783 55.8405C33.7428 55.9013 33.2693 56.4436 33.3341 57.0467L33.3502 57.3867C33.4231 57.9897 33.9978 58.4228 34.6333 58.35Z",
    fill: "url(#paint18_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6333 58.3491L40.8097 57.7622C41.429 57.6934 41.8661 57.0863 41.7932 56.4913L41.7811 56.3901C41.7082 55.7992 41.1416 55.2973 40.5223 55.354L34.3783 55.8356C33.7428 55.8963 33.2693 56.4387 33.3341 57.0418L33.3502 57.3818C33.4231 57.9889 33.9978 58.422 34.6333 58.3491Z",
    fill: "url(#paint19_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6452 47.0579L41.5704 46.5075C42.2706 46.4387 42.7442 45.7182 42.643 45.0504L42.6066 44.7752C42.5054 44.1074 41.8538 43.6055 41.1495 43.6581L34.2567 44.0912C33.5322 44.1478 33.0384 44.9209 33.1153 45.6656L33.1234 45.7668C33.2205 46.4468 33.9248 47.1268 34.6452 47.0579Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8143 46.9246L41.5898 46.3863C42.2698 46.3175 42.7393 45.6699 42.6381 45.0142L42.6057 44.7593C42.5086 44.1036 41.8691 43.5976 41.185 43.6502L34.446 44.0752C33.7418 44.1278 33.252 44.8078 33.333 45.508L33.3532 45.7428C33.4422 46.4147 34.1141 46.9934 34.8143 46.9246Z",
    fill: "url(#paint20_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9845 46.7946L41.6061 46.2684C42.2659 46.2037 42.7273 45.6249 42.6301 44.9813L42.6018 44.7506C42.5047 44.1071 41.8814 43.6011 41.2176 43.6497L34.6283 44.0626C33.9443 44.1152 33.4586 44.694 33.5476 45.3496L33.576 45.722C33.6691 46.3777 34.3005 46.8593 34.9845 46.7946Z",
    fill: "url(#paint21_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9845 46.7945L41.6061 46.2684C42.2659 46.2036 42.7192 45.552 42.622 44.9125L42.6059 44.8032C42.5087 44.1596 41.8814 43.6051 41.2176 43.6578L34.6283 44.0706C33.9443 44.1232 33.4586 44.702 33.5476 45.3577L33.576 45.7301C33.6691 46.3777 34.3005 46.8593 34.9845 46.7945Z",
    fill: "url(#paint22_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3052 51.645L62.107 50.3418C62.7789 50.2608 63.2767 49.5606 63.2241 48.9171L63.2039 48.6499C63.1512 48.0104 62.5563 47.5369 61.8844 47.6016L48.0623 48.7956C47.3702 48.8644 46.8602 49.6173 46.9007 50.3296L46.9047 50.4268C46.9655 51.0865 47.613 51.73 48.3052 51.645Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4706 51.5153L62.1308 50.2282C62.7824 50.1513 63.2722 49.5159 63.2155 48.8885L63.1993 48.6457C63.1467 48.0183 62.5679 47.5407 61.9122 47.6055L48.2359 48.7874C47.56 48.8521 47.0621 49.5119 47.1107 50.1837L47.1188 50.4104C47.1835 51.0499 47.7988 51.5963 48.4706 51.5153Z",
    fill: "url(#paint23_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6362 51.3853L62.1547 50.1103C62.7901 50.0334 63.2637 49.4668 63.211 48.8516L63.1989 48.633C63.1463 48.0178 62.5837 47.5402 61.9482 47.6009L48.4135 48.7666C47.7579 48.8313 47.2681 49.398 47.3248 50.0253L47.3369 50.3815C47.3976 51.0129 47.9845 51.4622 48.6362 51.3853Z",
    fill: "url(#paint24_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6362 51.3874L62.1547 50.1125C62.7901 50.0356 63.2637 49.4042 63.211 48.7849L63.203 48.6797C63.1503 48.0645 62.5877 47.5383 61.9482 47.6031L48.4135 48.7687C47.7579 48.8335 47.2681 49.4001 47.3248 50.0275L47.3369 50.3837C47.3976 51.0151 47.9845 51.4643 48.6362 51.3874Z",
    fill: "url(#paint25_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3158 52.9841L44.3049 52.0654C44.9768 51.9925 45.4544 51.2964 45.3734 50.6569L45.3451 50.3897C45.2642 49.7502 44.6489 49.2726 43.973 49.3333L33.996 50.1428C33.2999 50.2035 32.8101 50.9483 32.8749 51.6647L32.883 51.7618C32.9518 52.4135 33.6237 53.061 34.3158 52.9841Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4814 52.854L44.3248 51.9514C44.9805 51.8785 45.446 51.2512 45.365 50.6238L45.3407 50.381C45.2598 49.7536 44.6608 49.276 44.001 49.3327L34.1657 50.13C33.4898 50.1867 33.0041 50.8424 33.0729 51.5143L33.0891 51.7409C33.17 52.3764 33.8055 52.9268 34.4814 52.854Z",
    fill: "url(#paint26_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6435 52.7285L44.3412 51.838C44.9766 51.7692 45.434 51.2066 45.3571 50.5914L45.3369 50.3729C45.26 49.7576 44.6731 49.276 44.0336 49.3327L34.344 50.1179C33.6842 50.1745 33.2066 50.7371 33.2835 51.3645L33.3078 51.7207C33.3847 52.344 33.9878 52.7973 34.6435 52.7285Z",
    fill: "url(#paint27_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6436 52.7297L44.3413 51.8392C44.9768 51.7704 45.4301 51.1431 45.3491 50.5238L45.337 50.4186C45.2601 49.8034 44.6692 49.2772 44.0297 49.3298L34.3401 50.115C33.6803 50.1717 33.2027 50.7343 33.2796 51.3616L33.3039 51.7178C33.3848 52.3452 33.9879 52.7985 34.6436 52.7297Z",
    fill: "url(#paint28_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3835 66.9215L68.6834 65.6061C69.331 65.5292 69.8086 64.8816 69.756 64.2947L69.7358 64.0519C69.6832 63.469 69.1084 63.04 68.4608 63.1088L55.1487 64.3271C54.4809 64.3959 53.9912 65.088 54.0316 65.7397L54.0357 65.8287C54.0964 66.4237 54.7197 67.0025 55.3835 66.9215Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5451 66.8009L68.7074 65.4976C69.3388 65.4207 69.8043 64.8378 69.7517 64.2631L69.7355 64.0405C69.6829 63.4657 69.1243 63.0408 68.4929 63.1015L55.3184 64.3036C54.6668 64.3683 54.1892 64.9755 54.2378 65.5907L54.2459 65.7971C54.3025 66.388 54.8975 66.8778 55.5451 66.8009Z",
    fill: "url(#paint29_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7031 66.6794L68.7278 65.3923C69.339 65.3154 69.7963 64.7973 69.7437 64.2347L69.7316 64.0324C69.679 63.4698 69.1366 63.0407 68.5214 63.1014L55.4845 64.2914C54.8531 64.3561 54.3796 64.8783 54.4362 65.453L54.4484 65.7768C54.5091 66.3515 55.0757 66.7563 55.7031 66.6794Z",
    fill: "url(#paint30_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7031 66.6796L68.7278 65.3925C69.339 65.3156 69.7923 64.7328 69.7397 64.1702L69.7316 64.073C69.679 63.5104 69.1326 63.0369 68.5214 63.1016L55.4845 64.2916C54.8531 64.3564 54.3796 64.8785 54.4362 65.4532L54.4484 65.777C54.5091 66.3518 55.0757 66.7565 55.7031 66.6796Z",
    fill: "url(#paint31_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0833 67.9612L51.4985 67.2934C52.1461 67.2124 52.5954 66.5689 52.5104 65.986L52.478 65.7432C52.393 65.1604 51.794 64.7354 51.1423 64.8042L44.7635 65.3708C44.0957 65.4396 43.6262 66.1318 43.6869 66.7793L43.695 66.8684C43.7719 67.4674 44.4155 68.0422 45.0833 67.9612Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2409 67.8442L51.5185 67.1926C52.1499 67.1157 52.591 66.5329 52.5061 65.9622L52.4777 65.7396C52.3927 65.1689 51.8099 64.7439 51.1744 64.8046L44.9333 65.3551C44.2816 65.4198 43.8202 66.0269 43.885 66.6381L43.9012 66.8445C43.9781 67.4314 44.5892 67.9211 45.2409 67.8442Z",
    fill: "url(#paint32_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3998 67.7229L51.5358 67.0875C52.1469 67.0106 52.58 66.4925 52.4991 65.9299L52.4748 65.7275C52.3939 65.169 51.8232 64.7399 51.2079 64.8007L45.1044 65.339C44.473 65.4037 44.0116 65.9259 44.0885 66.4965L44.1087 66.8203C44.1856 67.3951 44.7684 67.7998 45.3998 67.7229Z",
    fill: "url(#paint33_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3977 67.723L51.5337 67.0875C52.1448 67.0106 52.5739 66.4319 52.4929 65.8693L52.4808 65.7721C52.3998 65.2136 51.8251 64.74 51.2099 64.8048L45.1063 65.3431C44.4749 65.4078 44.0135 65.93 44.0904 66.5007L44.1106 66.8245C44.1835 67.3951 44.7663 67.7999 45.3977 67.723Z",
    fill: "url(#paint34_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5801 68.9603L41.0075 68.2925C41.6551 68.2115 42.0881 67.572 41.9829 66.9892L41.9424 66.7464C41.8372 66.1635 41.222 65.7426 40.5703 65.8074L34.1754 66.374C33.5035 66.4428 33.0542 67.1309 33.1392 67.7825L33.1514 67.8716C33.2485 68.4665 33.9123 69.0413 34.5801 68.9603Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7371 68.839L41.0228 68.1874C41.6542 68.1105 42.0792 67.5276 41.974 66.9569L41.9376 66.7343C41.8364 66.1636 41.2333 65.7386 40.5978 65.8034L34.3445 66.3579C33.6929 66.4227 33.2477 67.0298 33.3327 67.641L33.3529 67.8474C33.4541 68.4302 34.0855 68.9199 34.7371 68.839Z",
    fill: "url(#paint35_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8916 68.7214L41.0397 68.0819C41.6549 68.005 42.0718 67.487 41.9706 66.9284L41.9423 66.7301C41.8411 66.1715 41.2542 65.7425 40.639 65.8073L34.5233 66.3456C33.8878 66.4103 33.4467 66.9284 33.5397 67.5031L33.5721 67.8269C33.6612 68.3936 34.2602 68.7983 34.8916 68.7214Z",
    fill: "url(#paint36_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8916 68.7204L41.0397 68.0809C41.6549 68.004 42.0637 67.4252 41.9625 66.8667L41.9463 66.7695C41.8451 66.211 41.2542 65.7415 40.639 65.8022L34.5233 66.3405C33.8878 66.4052 33.4467 66.9233 33.5397 67.4981L33.5721 67.8219C33.6612 68.3926 34.2602 68.7973 34.8916 68.7204Z",
    fill: "url(#paint37_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2731 73.5356L61.1683 72.204C61.7956 72.123 62.257 71.4997 62.2004 70.9371L62.1801 70.7024C62.1235 70.1398 61.569 69.735 60.9376 69.7998L48.0302 71.0342C47.3826 71.1031 46.9131 71.7709 46.9536 72.3982L46.9577 72.4832C47.0224 73.062 47.6295 73.6165 48.2731 73.5356Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4308 73.4175L61.1924 72.1021C61.8036 72.0252 62.2529 71.4626 62.2003 70.9081L62.1841 70.6936C62.1314 70.1431 61.5891 69.7343 60.9739 69.795L48.2001 71.0174C47.5687 71.0821 47.1073 71.669 47.1559 72.2599L47.1639 72.4583C47.2247 73.0249 47.7994 73.4985 48.4308 73.4175Z",
    fill: "url(#paint38_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5849 73.3003L61.213 71.997C61.808 71.9201 62.2451 71.4182 62.1925 70.8759L62.1803 70.6816C62.1277 70.1392 61.5975 69.7304 61.0025 69.7911L48.3623 71.0013C47.7511 71.0661 47.2938 71.572 47.3505 72.1225L47.3626 72.4341C47.4233 72.9927 47.9738 73.3812 48.5849 73.3003Z",
    fill: "url(#paint39_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5848 73.2998L61.2129 71.9965C61.8078 71.9196 62.245 71.357 62.1923 70.8147L62.1842 70.7216C62.1316 70.1792 61.6014 69.73 61.0064 69.7907L48.3662 71.0009C47.7551 71.0656 47.2977 71.5716 47.3544 72.122L47.3665 72.4337C47.4232 72.9922 47.9736 73.3808 48.5848 73.2998Z",
    fill: "url(#paint40_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1994 74.9992L44.5085 73.9711C45.1359 73.8902 45.5689 73.2709 45.4839 72.7083L45.4516 72.4776C45.3666 71.9191 44.7837 71.5143 44.1523 71.5791L34.8553 72.514C34.2077 72.5828 33.7585 73.2507 33.8273 73.874L33.8354 73.959C33.9204 74.5297 34.5518 75.0842 35.1994 74.9992Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.353 74.886L44.5286 73.8701C45.1398 73.7932 45.5647 73.2306 45.4838 72.6801L45.4555 72.4656C45.3705 71.9152 44.8038 71.5104 44.1886 71.5752L35.0252 72.4939C34.3938 72.5587 33.9526 73.1456 34.0254 73.7325L34.0416 73.9308C34.1226 74.4934 34.7216 74.9629 35.353 74.886Z",
    fill: "url(#paint41_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5036 74.7679L44.5457 73.7682C45.1406 73.6913 45.5575 73.1894 45.4766 72.6511L45.4523 72.4568C45.3713 71.9185 44.8168 71.5097 44.2219 71.5704L35.192 72.4771C34.5768 72.5418 34.1396 73.0437 34.2206 73.5942L34.2449 73.9058C34.3218 74.4603 34.8925 74.8448 35.5036 74.7679Z",
    fill: "url(#paint42_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5017 74.7675L44.5437 73.7677C45.1387 73.6908 45.5475 73.1323 45.4665 72.5899L45.4544 72.4968C45.3734 71.9585 44.8149 71.5093 44.2199 71.57L35.19 72.4766C34.5748 72.5414 34.1377 73.0432 34.2186 73.5937L34.2429 73.9053C34.3198 74.4598 34.8905 74.8444 35.5017 74.7675Z",
    fill: "url(#paint43_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4244 58.0343L54.0614 57.0952C54.713 57.0224 55.1987 56.3465 55.1502 55.7313L55.134 55.4763C55.0854 54.861 54.5147 54.4037 53.8631 54.4644L44.2382 55.2982C43.5663 55.3589 43.0645 56.0834 43.0887 56.7714L43.0928 56.8645C43.1414 57.4919 43.7566 58.1112 44.4244 58.0343Z",
    fill: "#CF8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5858 57.909L54.0852 56.9822C54.7166 56.9093 55.1942 56.3022 55.1457 55.6951L55.1335 55.4603C55.085 54.8572 54.5305 54.3958 53.895 54.4565L44.4118 55.2782C43.7602 55.3389 43.2623 55.9703 43.2988 56.6179L43.3028 56.8364C43.3514 57.4598 43.9342 57.9859 44.5858 57.909Z",
    fill: "url(#paint44_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7518 57.7868L54.1095 56.8721C54.7247 56.8033 55.1902 56.2609 55.1416 55.6659L55.1335 55.4555C55.0849 54.8645 54.5466 54.4031 53.9274 54.4598L44.5818 55.2693C43.9463 55.3259 43.4606 55.8724 43.5092 56.4754L43.5132 56.8195C43.5578 57.4225 44.1163 57.8597 44.7518 57.7868Z",
    fill: "url(#paint45_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7518 57.7864L54.1095 56.8717C54.7247 56.8029 55.1861 56.1917 55.1375 55.6008L55.1335 55.4996C55.0849 54.9087 54.5426 54.4028 53.9274 54.4594L44.5818 55.2689C43.9463 55.3256 43.4606 55.872 43.5092 56.4751L43.5132 56.8191C43.5578 57.4222 44.1163 57.8593 44.7518 57.7864Z",
    fill: "url(#paint46_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.979 71.5801L38.3284 80.4683C38.3284 80.4683 41.6069 95.7758 36.9199 96.6946L95.3976 88.6765C95.4017 88.6765 102.424 85.4022 101.979 71.5801Z",
    fill: "url(#paint47_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.511788,
    filter: "url(#filter1_f_35154_85969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6373 95.109C82.5994 95.109 88.2434 89.4445 88.2434 82.4569C88.2434 75.4693 82.5994 69.8047 75.6373 69.8047C68.6752 69.8047 63.0312 75.4693 63.0312 82.4569C63.0312 89.4445 68.6752 95.109 75.6373 95.109Z",
    fill: "url(#paint48_linear_35154_85969)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M70.6844 19.1208C74.7957 19.1208 78.1286 15.7879 78.1286 11.6766C78.1286 7.56529 74.7957 4.23242 70.6844 4.23242C66.5731 4.23242 63.2402 7.56529 63.2402 11.6766C63.2402 15.7879 66.5731 19.1208 70.6844 19.1208Z",
    fill: "url(#paint49_linear_35154_85969)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M21.1183 18.9474C23.806 18.9474 25.9847 16.7727 25.9847 14.0899C25.9847 11.4072 23.806 9.23242 21.1183 9.23242C18.4307 9.23242 16.252 11.4072 16.252 14.0899C16.252 16.7727 18.4307 18.9474 21.1183 18.9474Z",
    fill: "url(#paint50_linear_35154_85969)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35154_85969",
    x: 2.02373,
    y: -15.5833,
    width: 100.404,
    height: 125.285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.661721
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5653
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.427451 0 0 0 0 0.537255 0 0 0 0.190587 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35154_85969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35154_85969",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_35154_85969",
    x: 60.3844,
    y: 67.1578,
    width: 30.5067,
    height: 30.5985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.32344,
    result: "effect1_foregroundBlur_35154_85969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35154_85969",
    x1: 52.18,
    y1: 14.1953,
    x2: 52.18,
    y2: 85.6808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6EAEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35154_85969",
    x1: 18.3171,
    y1: 94.4488,
    x2: 26.4434,
    y2: 78.9483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35154_85969",
    x1: 60.5815,
    y1: 22.6135,
    x2: 27.6703,
    y2: 69.9947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35154_85969",
    x1: 32.6242,
    y1: 19.881,
    x2: 29.5315,
    y2: -0.673034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3744,
    stopColor: "#DDDFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#D6D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6562,
    stopColor: "#C3C6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8439,
    stopColor: "#A5A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35154_85969",
    x1: 49.6314,
    y1: 1.54915,
    x2: 57.1159,
    y2: 91.0748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1621,
    stopColor: "#F5F6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2048,
    stopColor: "#F1F3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6068,
    stopColor: "#EFF1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7955,
    stopColor: "#E7EAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8888,
    stopColor: "#E0E3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35154_85969",
    x1: 48.9425,
    y1: 19.0148,
    x2: 49.3208,
    y2: 26.2176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    stopColor: "#50D2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37CDE2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_35154_85969",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8.98224 1.00064 1.15459 7.78419 35.2284 24.6855)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3284,
    stopColor: "#00759A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#117FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3571,
    stopColor: "#3E98B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3836,
    stopColor: "#86C1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4092,
    stopColor: "#D2EBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4249,
    stopColor: "#7DBBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4386,
    stopColor: "#3A95B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4485,
    stopColor: "#107EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4536,
    stopColor: "#00759A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_35154_85969",
    x1: 49.562,
    y1: 29.8189,
    x2: 49.736,
    y2: 32.8136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    stopColor: "#50D2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37CDE2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_35154_85969",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.74874 0.436067 0.503009 3.24876 43.8175 32.2139)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3284,
    stopColor: "#00759A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#117FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3571,
    stopColor: "#3E98B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3836,
    stopColor: "#86C1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4092,
    stopColor: "#D2EBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4249,
    stopColor: "#7DBBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4386,
    stopColor: "#3A95B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4485,
    stopColor: "#107EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4536,
    stopColor: "#00759A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_35154_85969",
    x1: 36.4335,
    y1: 30.6964,
    x2: 36.6075,
    y2: 33.6896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7267,
    stopColor: "#50D2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37CDE2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_35154_85969",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.75459 0.436747 0.503794 3.25382 33.9617 32.8969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3284,
    stopColor: "#00759A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#117FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3571,
    stopColor: "#3E98B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3836,
    stopColor: "#86C1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4092,
    stopColor: "#D2EBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4249,
    stopColor: "#7DBBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4386,
    stopColor: "#3A95B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4485,
    stopColor: "#107EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4536,
    stopColor: "#00759A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_35154_85969",
    x1: 72.9938,
    y1: 76.1922,
    x2: 72.9941,
    y2: 76.1921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_35154_85969",
    x1: 69.9405,
    y1: 42.3246,
    x2: 56.0981,
    y2: 44.3133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_35154_85969",
    x1: 62.8904,
    y1: 41.2332,
    x2: 63.0952,
    y2: 44.4494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_35154_85969",
    x1: 73.008,
    y1: 76.3885,
    x2: 73.0082,
    y2: 76.3885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_35154_85969",
    x1: 53.9012,
    y1: 43.6644,
    x2: 44.94,
    y2: 44.9519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_35154_85969",
    x1: 49.297,
    y1: 42.2321,
    x2: 49.502,
    y2: 45.4522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_35154_85969",
    x1: 73.8357,
    y1: 87.9843,
    x2: 73.8358,
    y2: 87.9843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_35154_85969",
    x1: 41.7609,
    y1: 56.2012,
    x2: 33.3603,
    y2: 57.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_35154_85969",
    x1: 37.4156,
    y1: 54.8969,
    x2: 37.6497,
    y2: 57.8588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_35154_85969",
    x1: 73.0099,
    y1: 76.4405,
    x2: 73.0101,
    y2: 76.4405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_35154_85969",
    x1: 42.5703,
    y1: 44.5249,
    x2: 33.5905,
    y2: 45.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_35154_85969",
    x1: 37.956,
    y1: 43.0919,
    x2: 38.1612,
    y2: 46.3159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_35154_85969",
    x1: 73.384,
    y1: 81.6663,
    x2: 73.3843,
    y2: 81.6663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_35154_85969",
    x1: 63.1557,
    y1: 48.308,
    x2: 47.3651,
    y2: 50.5765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_35154_85969",
    x1: 55.0948,
    y1: 47.4409,
    x2: 55.3565,
    y2: 50.5566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_35154_85969",
    x1: 73.4204,
    y1: 82.1946,
    x2: 73.4206,
    y2: 82.1946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_35154_85969",
    x1: 45.3003,
    y1: 50.1179,
    x2: 33.3249,
    y2: 51.8383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_35154_85969",
    x1: 39.1707,
    y1: 48.9362,
    x2: 39.4027,
    y2: 52.1099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_35154_85969",
    x1: 74.5142,
    y1: 97.4841,
    x2: 74.5145,
    y2: 97.4841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_35154_85969",
    x1: 69.6936,
    y1: 63.7516,
    x2: 54.4756,
    y2: 65.9379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_35154_85969",
    x1: 61.9256,
    y1: 62.998,
    x2: 62.1764,
    y2: 65.8689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_35154_85969",
    x1: 74.5595,
    y1: 98.1158,
    x2: 74.5597,
    y2: 98.1158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_35154_85969",
    x1: 52.4588,
    y1: 65.6169,
    x2: 44.1108,
    y2: 66.8162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_35154_85969",
    x1: 48.1304,
    y1: 64.4032,
    x2: 48.3767,
    y2: 67.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_35154_85969",
    x1: 74.5742,
    y1: 98.3354,
    x2: 74.5743,
    y2: 98.3354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_35154_85969",
    x1: 41.9246,
    y1: 66.616,
    x2: 33.5679,
    y2: 67.8166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_35154_85969",
    x1: 37.5933,
    y1: 65.4005,
    x2: 37.8398,
    y2: 68.2207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_35154_85969",
    x1: 74.5556,
    y1: 103.363,
    x2: 74.5547,
    y2: 103.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_35154_85969",
    x1: 62.1418,
    y1: 70.4072,
    x2: 47.391,
    y2: 72.6039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_35154_85969",
    x1: 54.6049,
    y1: 69.7358,
    x2: 54.8592,
    y2: 72.4861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_35154_85969",
    x1: 74.6038,
    y1: 104.008,
    x2: 74.6031,
    y2: 104.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_35154_85969",
    x1: 45.4275,
    y1: 72.295,
    x2: 34.2513,
    y2: 73.9594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_35154_85969",
    x1: 39.6774,
    y1: 71.3323,
    x2: 39.935,
    y2: 74.1189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_35154_85969",
    x1: 73.8358,
    y1: 87.9806,
    x2: 73.836,
    y2: 87.9806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_35154_85969",
    x1: 55.1037,
    y1: 55.242,
    x2: 43.5234,
    y2: 56.9057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_35154_85969",
    x1: 49.1619,
    y1: 54.1145,
    x2: 49.4024,
    y2: 57.1576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_35154_85969",
    x1: 66.7366,
    y1: 72.8272,
    x2: 73.153,
    y2: 99.5687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3744,
    stopColor: "#DDDFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4893,
    stopColor: "#D6D8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6562,
    stopColor: "#C3C6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8439,
    stopColor: "#A5A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_35154_85969",
    x1: 62.582,
    y1: 101.306,
    x2: 80.3766,
    y2: 67.4875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_35154_85969",
    x1: 62.9749,
    y1: 22.7668,
    x2: 73.4231,
    y2: 2.83756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_35154_85969",
    x1: 16.0785,
    y1: 21.3265,
    x2: 22.8891,
    y2: 8.31203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35154_85969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocuments);
export default __webpack_public_path__ + "static/media/no-documents.81c19930648bd514fab2f9b328cd1c66.svg";
export { ForwardRef as ReactComponent };